import * as angular from "angular";
import {IController, IScope, ITimeoutService, IWindowService} from "angular";
import * as _ from 'lodash';
import {AnalyticsService} from "../../../commons/services/analytics-service.service";
import {$accountsFactory} from "../../../account/$accounts.factory";
import {SplitService} from "../../../commons/services/split-service.service";
import {PlanningAlertsService} from "../../services/planning-alerts.service";
import {PlanningDialogService} from "../../services/planning-dialogs-service.service";
import {PlanningDraftsService} from "../../services/planning-drafts-service.service";
import {DraftJobChangesSyncState} from "../../types/draft-job-changes-sync-state.enum";
import {ConfirmDialogService} from "../../../commons/services/confirm-dialog.service";
import {CustomPanelService} from "../../../commons/services/custom-panel.service";
import {RouteSwapResourceRequestModel} from "../../models/route-swap-resource-request.model";
import {PlanningPanelModel} from "../../models/planning-panel.model";
import {
  ViewSettingsHolderType,
  ViewSettingsModel,
  ViewSettingsType
} from "../../../commons/models/view-settings.model";
import {ViewSettingsService} from "../../../commons/services/view-settings-service.service";
import {PlanningViewSettingsModel} from "../../models/planning-view-settings.model";
import {ResizeService} from "../../../commons/services/resize-service.service";
import {PlanningDraftExportType} from "../../types/planning-draft-export.type";
import {PlanningProjectsService} from "../../services/planning-projects-service.service";
import {
  EditRouteResourceNamePanelService
} from "../../services/edit-route-resource-name-panel.service";
import {
  PlanningDraftEditRouteNameRequestModel
} from "../../models/planning-draft-edit-route-name-request.model";
import {PlanningCommonService} from "../../services/planning-coomon-service.service";
import {SiteFiltersType} from "../../../commons/types/site-filters.type";
import {
  PlanningGroupedJobsListPanelComponent
} from "../../angular/components/planning-grouped-jobs-list-panel/planning-grouped-jobs-list-panel.component";
import {PanelService} from "../../../commons/angular/services/panel.service";
import {BreadcrumbsService} from "../../../commons/angular/services/breadcrumbs.service";
import {PlanningTemplateDefaultDraftService} from "../../services/planning-template-default-draft.service";
import {
  PlanningDraftRoutePanelContextMenuComponent
} from "../../angular/components/planning-draft-route-panel-context-menu/planning-draft-route-panel-context-menu.component";
import {
  PlanningDraftRouteJobSplitByPackagesComponent
} from "../../angular/components/planning-draft-route-job-split-by-packages/planning-draft-route-job-split-by-packages.component";
import {
  PlanningDraftRouteJobSplitByLocationComponent
} from "../../angular/components/planning-draft-route-job-split-by-location/planning-draft-route-job-split-by-location.component";
import {Subscription} from "rxjs";
import {
  PlanningDraftRouteJobSplitRevertComponent
} from "../../angular/components/planning-draft-route-job-split-revert/planning-draft-route-job-split-revert.component";
import {PlanningRouteModel} from "../../models/planning-route.model";
import {MapLayersSettings} from "../../../map/models/map-layers-settings.model";
import {PlanningDraftEditRouteColorRequestModel} from "../../models/planning-draft-edit-route-color-request.model";
import {
  BringozMenuPanelComponent
} from "../../../commons/angular/components/bringoz-menu-panel/bringoz-menu-panel.component";
import {PlanningViewMode} from "../../types/planning-view-mode.enum";
import {
  MIN_PANEL_SIZE,
  MAX_DOCKED_PANEL, EXPORT_EXCEL_SIZE_LIMIT,
} from "../../../commons/angular/constants/commons";
import {DepotModel} from "../../../depots/angular/models/depot.model";
import {PLANNING_DRAFT_JOB_MENU_ITEMS} from "../../angular/constants/planning-draft-job-menu.constant";

const MIN_PANEL_WIDTH: number = 380;

export class PlanningProjectDraftViewNewComponent implements IController {

  project: any;
  projectStatus: any;
  draft: any;
  analysis: any;
  jobs: any[];
  viewSettings: ViewSettingsModel;
  viewSettingsColumns: ViewSettingsModel;


  public routes: any[];
  public resources: any[];
  public depots: DepotModel[];
  public panels: PlanningPanelModel[] = [];
  public viewConfiguration: PlanningViewSettingsModel;
  public minimizedPanels: PlanningPanelModel[] = [];
  public showPanels: boolean = true;
  public showMap: boolean = true;
  public PlanningViewMode = PlanningViewMode;
  public viewMode: PlanningViewMode = PlanningViewMode.CARDS;
  public isLoading: boolean;
  public visibleMinimizedPanelsCount: number = 0;
  public isMorePanelsDropdownOpen: boolean = false;
  private documentClickListener: any;
  private mapContainerResizeObserver: any;
  public leftoverStops: any[];
  public selectedJobIds: any[];
  public selectedRouteIds: any[];
  public selectedResourceIds: any[];
  public selectedLeftoverIds: any[];
  public selectedJobToView: any;
  public selectedRouteToViewResource: any;
  public sortJobsSlaType: any;
  public highlightedActivity: any;
  public selectedRouteId: any;
  public hiddenRouteIds: any[];
  // Map View Options toggles. Owned here so they survive the map being unmounted/remounted
  // (toggling the map off/on, switching Cards <-> Table), and persisted with the view settings.
  public mapLayers: MapLayersSettings;
  private isInitialRoutesLoad: boolean = true;
  private _pendingViewSettingsUpdate: angular.IPromise<void>;
  public canEdit: boolean;
  public isGroupedRoutes: any;
  public filterConfig: {
    queryString: string,
    jobsSelectedSkills: any,
    jobsSelectedResourceIds: any,
    selectedServiceAreasIds: any,
    jobsSelectedTagNames: any,
    resourcesSelectedSkills: any,
    jobsInRouteQuery: any,
    jobsIsPackedQuery: any,
    resourcesInRouteQuery: any
  };
  public isTimelineFullScreen: boolean;
  public timelineEnabled: boolean;
  public serviceAreas: any[];
  public clusteringAreas: any[] = [];
  public selectedJobs: any[];
  public zoomActivityId?: string;
  public planningDraftExportType: typeof PlanningDraftExportType = PlanningDraftExportType;

  private draftRef: any;
  private draftRoutesRef: any;
  private serviceAreasRef: any;
  private jobSourceTypes: any;
  private resourceAgentSkills: any;
  public leftoverJobs: any;
  private currentlyFetchingRouteIds = [];
  private highlightedActivityRoute: any;
  private highlightedActivityJobs: any[];
  private selectedRouteToViewInMiniSection: any;
  private routeWarningsRef: any;
  private loadedClusteringAreaIdsKey: string;
  private selectedOverviewType: string = 'draft';
  private accountsRef: any;
  private isDuplicateDraftDisabled: boolean;
  private _jobSplitPanelSubscription: Subscription;
  private _jobSplitSubscription: Subscription;
  public visibleMinimizedPanels: PlanningPanelModel[];
  public invisibleMinimizedPanels: PlanningPanelModel[];
  public siteFiltersType: typeof SiteFiltersType = SiteFiltersType;
  public isBigScreen: boolean;
  public isMapToggled: boolean = false;
  public isShowMultipleJobSplit = this.splitService.getIsEnablePlanningJobSplit();
  public selectedClusterId: string = '';
  public highlightedRouteIds: Set<string> | null = null;
  public highlightedLeftoverIds: Set<string> | null = null;

  public tablePanelsWidth: number = 680;
  public activePanelId: string;
  public isResizingTableMode: boolean = false;
  private tableMouseMoveListener: any;
  private tableMouseUpListener: any;
  private keydownHandlerBound: any;
  private resizeHandlerBound: any;

  /* @ngInject */
  constructor(private $serviceArea, private planningConstants, private agentConstants, private planningDraftsService: PlanningDraftsService,
              private $log, private planningDialogService: PlanningDialogService, private TimelineService, private $drafts, private editRouteResourceNamePanelService: EditRouteResourceNamePanelService,
              private $draftRoutes, private $state, private confirmDialogService: ConfirmDialogService, private $timeout: ITimeoutService, private planningProjectsService: PlanningProjectsService,
              private planningAlertsService: PlanningAlertsService, private $filter, private splitService: SplitService, private analyticsService: AnalyticsService,
              private $window: IWindowService, private $accounts: $accountsFactory, private moment, private viewSettingsService: ViewSettingsService,
              private resizeService: ResizeService, private planningCommonService: PlanningCommonService, private panelService: PanelService,
              private $scope: IScope, private $mdMedia, private $mdDialog, private breadcrumbsService: BreadcrumbsService, private UUIDService,
              private planningTemplateDefaultDraftService: PlanningTemplateDefaultDraftService, private $planningTemplatesDefaultDraft, private $q: angular.IQService, private planningClusteringAreasRequestsService) {
    this.serviceAreasRef = this.$serviceArea();
    this.accountsRef = this.$accounts();
    this.jobSourceTypes = this.planningConstants.jobsSourceTypes;
    this.resourceAgentSkills = this.agentConstants.skills;
    this.draftRoutesRef = this.$draftRoutes();

    // Close dropdown when clicking outside
    this.documentClickListener = (event) => {
      if (this.isMorePanelsDropdownOpen) {
        const morePanelsBox = document.querySelector('.more-panels-box');
        if (morePanelsBox && !morePanelsBox.contains(event.target as Node)) {
          this.isMorePanelsDropdownOpen = false;
        }
      }
    };
    this.$window.addEventListener('click', this.documentClickListener);
  }

  $onInit() {

    this.keydownHandlerBound = this.keydownHandler.bind(this);
    angular.element(this.$window).on('keydown', this.keydownHandlerBound);

    this.breadcrumbsService.off();
    this.isBigScreen = this.$mdMedia('gt-md');
    // Add window resize event listener
    this.resizeHandlerBound = () => {
      this.constrainTablePanelsWidth();
      this.calculateVisibleMinimizedPanelsCount();
    };
    angular.element(this.$window).on('resize', this.resizeHandlerBound);

    // Initial calculation after DOM is ready
    this.$timeout(() => {
      this.calculateVisibleMinimizedPanelsCount();

      // Initialize ResizeObserver for map container
      this.initMapContainerResizeObserver();
    }, 0);

    this.isLoading = false;
    this.leftoverStops = [];
    this.selectedJobIds = [];
    this.selectedJobs = [];
    this.selectedRouteIds = [];
    this.selectedResourceIds = [];
    this.selectedLeftoverIds = [];
    this.selectedJobToView = undefined;
    this.selectedRouteToViewResource = undefined;
    this.highlightedActivity = undefined;
    this.highlightedActivityJobs = undefined;
    this.selectedRouteId = undefined;
    this.hiddenRouteIds = [];

    this.canEdit = true;
    this.isGroupedRoutes = true; // Is bundled routes or regular (group/ungroup routes)

    this.filterConfig = {
      queryString: undefined,
      jobsSelectedSkills: undefined,
      jobsSelectedResourceIds: undefined,
      selectedServiceAreasIds: undefined,
      jobsSelectedTagNames: undefined,
      resourcesSelectedSkills: undefined,
      jobsInRouteQuery: undefined,
      jobsIsPackedQuery: undefined,
      resourcesInRouteQuery: undefined
    }

    this.sortJobsSlaType = 'desc';

    this.isTimelineFullScreen = false;
    this.timelineEnabled = true;

    // if (!this.jobs) {
    //   this.jobs = [];
    // }

    if (!this.resources) {
      this.resources = [];
    }

    if (!this.routes) {
      this.routes = [];
    }

    if (!this.serviceAreas) {
      this.serviceAreas = [];
    }

    if (!this.depots) {
      this.depots = [];
    }

    const hasViewConfigurationDefaultChanged = !!this.viewSettingsColumns?.settings?.viewConfiguration && this._getHasDefaultViewSettingsChanged(this.viewSettingsColumns.settings.viewConfiguration);

    if (!this.viewSettingsColumns?.settings?.viewConfiguration || hasViewConfigurationDefaultChanged) {
      this.viewConfiguration = this._getDefaultViewSettings();
    } else {
      this.viewConfiguration = angular.copy(this.viewSettingsColumns.settings.viewConfiguration)
    }

    if (!this.viewSettings) {
      this.onAddPanel();
    } else {
      this.panels = this.viewSettings.settings?.panels.filter((p: PlanningPanelModel) => {
        return !p.isMinimized;
      }) || [];
      this.minimizedPanels = this.viewSettings.settings?.panels.filter((p: PlanningPanelModel) => {
        return !!p.isMinimized;
      }) || [];
      if (this.viewSettings.settings?.viewMode) {
        this.viewMode = this.viewSettings.settings.viewMode;
      }
      if (!_.isUndefined(this.viewSettings.settings?.showMap)) {
        this.showMap = this.viewSettings.settings.showMap;
      }
      if (!_.isUndefined(this.viewSettings.settings?.showPanels)) {
        this.showPanels = this.viewSettings.settings.showPanels;
      }
      if (!_.isUndefined(this.viewSettings.settings?.tablePanelsWidth)) {
        this.tablePanelsWidth = this.viewSettings.settings.tablePanelsWidth;
      }
      this.mapLayers = this.viewSettings.settings?.mapLayers;
      this.constrainTablePanelsWidth();
    }

    if (!this.viewSettings || _.isUndefined(this.viewSettings.settings?.showMap)) {
      if (this.panels?.length >= 3 && !this.isBigScreen) {
        this.showMap = false;
      }
    }

    // If there is a loader on Remove it
    if (!!document.querySelector('md-dialog')) {
      this.$mdDialog.cancel();
    }
    // if (document.body.classList.contains('md-dialog-is-showing')) {
    //   document.body.classList.remove("md-dialog-is-showing");
    // }

    // ctrl.hiddenRouteIds = _.map(ctrl.routes, 'id');

    // Init Draft - Depots
    this._getDepots();

    // Init Draft - Jobs
    // this.jobs = this._getSortedJobs(this.jobs);
    this._getJobs();

    // Init Draft - Resources
    this._getDraftResources(); // TODO Check if can be removed... if creating a new route there is no resources to choose from.

    // Init Draft
    this._setDraftData(this.draft);
    // this.onAddPanel();
    this._bindDraftEventListener();
    this._bindDraftRoutesEventListener();
  }

  keydownHandler(event) {
    if (event.key === 'Escape') {
      this.selectedJobIds = [];
      this._setSelectedLeftoverIds(this.selectedJobIds);
      // this.jobs = this._getSortedJobs(this.jobs);
      this.setSelectedJobs();
      this.$timeout(() => {
      }, 0);
    }
  };


  $onChanges(onChangesObj: angular.IOnChangesObject) {
    if (onChangesObj.projectStatus && _.isEqual(this.projectStatus, 'RUNNING')) {
      this.planningDialogService.draftDispatchingLoader(this.project.id, this.project.selectedDraftId)
        .then(() => {
          if (_.isEqual(this.projectStatus, 'DISPATCHED')) {
            this.planningAlertsService.approveAndDispatchDraftSuccess();
            this.$state.go(this.planningConstants.states.completed, {draftId: this.project.selectedDraftId});
          }
        })
        .catch(() => {
          this.$log.info('Dialog Closed');
        })
    }
  }

  $onDestroy() {
    this._flushViewSettingsUpdate();

    // Safety net: draftRef.$destroy() below kills the websocket ref that would eventually deliver
    // the OPTIMIZED status update that closes this loader. If we navigate away while it's still
    // showing (status IN_PROGRESS), that update never arrives - close it now, before this view's
    // container is torn down, so $mdDialog isn't left with a DOM node destroyed out from under it.
    this.planningDialogService.draftOptimizingLoader(false);

    if (this.draftRef) {
      this.draftRef.$destroy();
    }

    if (this.draftRoutesRef) {
      this.draftRoutesRef.$destroyChannel();
    }

    if (this._jobSplitSubscription) {
      this._jobSplitSubscription.unsubscribe();
    }
    if (this._jobSplitPanelSubscription) {
      this._jobSplitPanelSubscription.unsubscribe();
    }

    // Disconnect ResizeObserver
    if (this.mapContainerResizeObserver) {
      this.mapContainerResizeObserver.disconnect();
      this.mapContainerResizeObserver = null;
    }

    // Remove click event listener for dropdown
    if (this.documentClickListener) {
      this.$window.removeEventListener('click', this.documentClickListener);
    }

    angular.element(this.$window).off('resize', this.resizeHandlerBound);

    angular.element(this.$window).off('keydown', this.keydownHandlerBound);

    if (this.tableMouseMoveListener) {
      this.$window.removeEventListener('mousemove', this.tableMouseMoveListener);
    }
    if (this.tableMouseUpListener) {
      this.$window.removeEventListener('mouseup', this.tableMouseUpListener);
    }

    this.breadcrumbsService.on();
  }

  initMapContainerResizeObserver() {
    if (typeof ResizeObserver !== 'undefined') {
      const mapContainer = document.querySelector('.map-container');
      if (this.mapContainerResizeObserver) {
        this.mapContainerResizeObserver.disconnect();
        this.mapContainerResizeObserver = null;
      }
      if (mapContainer) {
        this.mapContainerResizeObserver = new ResizeObserver(() => {
          this.calculateVisibleMinimizedPanelsCount();
        });

        this.mapContainerResizeObserver.observe(mapContainer);
      }
    }
  }

  // ******************************
  //        Public methods
  // ******************************

  onTableResizerMouseDown(event: MouseEvent) {
    this.isResizingTableMode = true;
    event.preventDefault();

    this.tableMouseMoveListener = this.onTableResizerMouseMove.bind(this);
    this.tableMouseUpListener = this.onTableResizerMouseUp.bind(this);

    this.$window.addEventListener('mousemove', this.tableMouseMoveListener);
    this.$window.addEventListener('mouseup', this.tableMouseUpListener);
  }

  onTableResizerMouseMove(event: MouseEvent) {
    if (this.isResizingTableMode) {
      const dockedPanelsCount = this.panels?.filter(p => !p.isFloating).length ?? 0;
      const minWidth: number = MIN_PANEL_WIDTH * dockedPanelsCount;
      const maxWidth: number = MIN_PANEL_WIDTH * MAX_DOCKED_PANEL;

      const targetWidth = Math.max(minWidth, Math.min(event.clientX, maxWidth));
      this.tablePanelsWidth = Math.min(targetWidth, this.$window.innerWidth - 10);
      this.$timeout(() => {}, 0);
    }
  }

  onTableResizerMouseUp() {
    this.isResizingTableMode = false;
    this.$window.removeEventListener('mousemove', this.tableMouseMoveListener);
    this.$window.removeEventListener('mouseup', this.tableMouseUpListener);
    this._updateViewSettings();
    this.resizeService.resize();
    this.$timeout(() => {}, 0);
  }

  onBackToProjects() {
    this.$state.go(this.planningConstants.states.projectsCalendar);
  }

  onAddPanel(tabIndex?, routeId?, routedServices?, isFloating?, resourceId?) {
    this._addPanel(tabIndex, routeId, routedServices, isFloating, resourceId);
    this._commitPanelsChange();
  }

  private _addPanel(tabIndex?, routeId?, routedServices?, isFloating?, resourceId?) {
    const panelsCopy: PlanningPanelModel[] = angular.copy(this.panels);
    const selectedTabIndex = _.isUndefined(tabIndex) ? 1 : tabIndex;

    const panel: PlanningPanelModel = {
      id: this.UUIDService.generate(),
      selectedTabIndex: selectedTabIndex,
      selectedRouteId: routeId,
      selectedResourceId: resourceId,
      tabsFilterConfig: {},
      width: 380
    };

    if (!panel.tabsFilterConfig[selectedTabIndex]) {
      panel.tabsFilterConfig[selectedTabIndex] = {};
    }

    if (!_.isUndefined(routedServices)) {
      panel.tabsFilterConfig[selectedTabIndex].inRoute = routedServices;
    }

    const dockedPanelsCount = _.filter(panelsCopy, (p) => !p.isFloating).length;
    if (isFloating || dockedPanelsCount >= MAX_DOCKED_PANEL) {
      panel.isFloating = true;
      panel.floatingPanelData = {
        position: { x: 120 + panelsCopy.length * 40, y: 120 + panelsCopy.length * 40 },
        size: MIN_PANEL_SIZE
      };
    }

    panelsCopy.push(panel);
    this.panels = panelsCopy;

    if (!this.isMapToggled) {
      this.showMap = !(this.panels?.length >= 3 && !this.isBigScreen);
    }
  }

  private _commitPanelsChange() {
    this.constrainTablePanelsWidth();
    this._updateViewSettings();

    this.$timeout(() => {}, 0);
  }

  onOpenInFloatingTable(tabIndex: number, id: string) {
    if (id) {
      if (tabIndex === 1) {
        this.onAddPanel(1, id, undefined, true);
      } else if (tabIndex === 2) {
        this.onAddPanel(2, undefined, undefined, true, id);
      }
    }
  }

  onDrillDown(routeId: string, index: number, event: any) {
    const panelsCopy: PlanningPanelModel[] = angular.copy(this.panels);

    const nextIndex = index + 1;
    const nextPanel = panelsCopy[nextIndex];

    if (nextPanel) {
      if (nextPanel.isPinned) {
        const newPanel: PlanningPanelModel = {
          id: this.moment().valueOf().toString(),
          selectedTabIndex: 1,
          selectedRouteId: routeId,
          tabsFilterConfig: {1: {}},
          width: 380
        };
        panelsCopy.splice(nextIndex, 0, newPanel);
        this.panels = panelsCopy;
        if (!this.isMapToggled) {
          this.showMap = !(this.panels?.length >= 3 && !this.isBigScreen);
        }
        this._updateViewSettings();
        return;
      } else {
        panelsCopy[nextIndex].selectedTabIndex = 1;
        panelsCopy[nextIndex].selectedRouteId = routeId;
        this.panels = panelsCopy;
        this._updateViewSettings();
        return;
      }
    }

    this.onAddPanel(1, routeId);
  }

  private _getPanelIndex(indexOrId: any, list: PlanningPanelModel[]): number {
    if (typeof indexOrId === 'number') {
      return indexOrId;
    }
    return list.findIndex(p => p.id === indexOrId);
  }

  onPanelTabChange(indexOrId: any, tab: number) {
    const panelsCopy: PlanningPanelModel[] = angular.copy(this.panels);
    const index = this._getPanelIndex(indexOrId, panelsCopy);
    if (index > -1 && panelsCopy[index]) {
      panelsCopy[index].selectedTabIndex = tab;
      this.panels = panelsCopy;
      this._updateViewSettings();
    }
  }

  onPanelRouteSelect(indexOrId: any, panel: PlanningPanelModel, route, isFloating?: boolean) {
    if (isFloating) {
      this.onOpenInFloatingTable(1, route?.id);
    } else {
      const panelsCopy: PlanningPanelModel[] = angular.copy(this.panels);
      const index = this._getPanelIndex(indexOrId, panelsCopy);
      if (index > -1 && panelsCopy[index]) {
        panelsCopy[index].selectedRouteId = route?.id;
        this.panels = panelsCopy;
        this._updateViewSettings();
      }
    }
  }

  onPanelChange(panel: PlanningPanelModel) {
    const panelIndex = this.panels.findIndex((p) => {
      return p.id === panel.id;
    })

    if (panelIndex > -1) {
      const panelsCopy = angular.copy(this.panels);
      panelsCopy.splice(panelIndex, 1, panel);
      this.panels = panelsCopy;

      this._updateViewSettings();
    }

  }

  onPinPanel(panelIndexOrId: any, isPinned: boolean) {
    const panelsCopy: PlanningPanelModel[] = angular.copy(this.panels);
    const index = this._getPanelIndex(panelIndexOrId, panelsCopy);
    if (index > -1 && panelsCopy[index]) {
      panelsCopy[index].isPinned = isPinned;
      this.panels = panelsCopy;
      this._updateViewSettings();
    }
  }

  onDuplicatePanel(indexOrId: any) {
    const panelsCopy: PlanningPanelModel[] = angular.copy(this.panels);
    const index = this._getPanelIndex(indexOrId, panelsCopy);
    if (index > -1 && panelsCopy[index]) {
      const panel = angular.copy(panelsCopy[index]);
      panel.id = this.moment().valueOf().toString();

      const dockedPanelsCount = _.filter(panelsCopy, (p) => !p.isFloating).length;
      if (panel.isFloating || dockedPanelsCount >= MAX_DOCKED_PANEL) {
        panel.isFloating = true;
        const data = this.getFloatingPanelData(panelsCopy[index], indexOrId);
        panel.floatingPanelData = {
          position: {
            x: data.position.x + 10,
            y: data.position.y + 10
          },
          size: { ...data.size }
        };
      }

      panelsCopy.push(panel);
      this.panels = panelsCopy;

      if (!this.isMapToggled) {
        this.showMap = !(this.panels?.length >= 3 && !this.isBigScreen);
      }

      this.constrainTablePanelsWidth();
      this._updateViewSettings();
      this.$timeout(() => {}, 0);
    }
  }

  onClosePanel(indexOrId: any, isMinimized?: boolean) {
    if (isMinimized) {
      const minimizedPanelsCopy: PlanningPanelModel[] = angular.copy(this.minimizedPanels);
      const index = this._getPanelIndex(indexOrId, minimizedPanelsCopy);
      if (index > -1) {
        minimizedPanelsCopy.splice(index, 1);
        this.minimizedPanels = minimizedPanelsCopy;
      }
    } else {
      const panelsCopy: PlanningPanelModel[] = angular.copy(this.panels);
      const index = this._getPanelIndex(indexOrId, panelsCopy);
      if (index > -1) {
        panelsCopy.splice(index, 1);
        this.panels = panelsCopy;
      }
    }

    if (!this.isMapToggled) {
      this.showMap = !(this.panels?.length >= 3 && !this.isBigScreen);
    }

    this._updateViewSettings();

    this.$timeout(() => {
      this.calculateVisibleMinimizedPanelsCount();
    }, 0);

    if (!this.panels.length) {
      this.showMap = true;
      this.timelineEnabled = false;
    }
  }

  getPanelTitle(panel: PlanningPanelModel, indexOrId: any): string {
    const index = this._getPanelIndex(indexOrId, this.panels);
    return 'Panel ' + (index > -1 ? index + 1 : 1);
  }

  getFloatingPanelData(panel: PlanningPanelModel, indexOrId: any): any {
    if (!panel.floatingPanelData) {
      const index = this._getPanelIndex(indexOrId, this.panels);
      const safeIndex = index > -1 ? index : 0;
      panel.floatingPanelData = {
        position: { x: 80 + safeIndex * 40, y: 80 + safeIndex * 40 },
        size: MIN_PANEL_SIZE
      };
    }
    return panel.floatingPanelData;
  }

  onFloatingPanelDataChange(event: any, indexOrId: any): void {
    const panelsCopy: PlanningPanelModel[] = angular.copy(this.panels);
    const index = this._getPanelIndex(indexOrId, panelsCopy);
    if (index > -1 && panelsCopy[index]) {
      panelsCopy[index].floatingPanelData = event;
      this.panels = panelsCopy;
      this._updateViewSettings();
    }
  }

  onFloatingPanelIsMinimizedChange(isMinimized: boolean, indexOrId: any): void {
    const panelsCopy: PlanningPanelModel[] = angular.copy(this.panels);
    const index = this._getPanelIndex(indexOrId, panelsCopy);
    if (index > -1 && panelsCopy[index]) {
      panelsCopy[index].isMinimized = isMinimized;
      this.panels = panelsCopy;
      this._updateViewSettings();
    }
  }

  onPanelClick(id: string): void {
    this.activePanelId = id;
  }

  onToggleFloatPanel(indexOrId: any, isFloating?: boolean): void {
    const panelsCopy: PlanningPanelModel[] = angular.copy(this.panels);
    const index = this._getPanelIndex(indexOrId, panelsCopy);
    if (index > -1 && panelsCopy[index]) {
      panelsCopy[index].isFloating = isFloating !== undefined ? isFloating : !panelsCopy[index].isFloating;
      this.panels = panelsCopy;
      this._updateViewSettings();
    }
  }

  hasDockedPanels(): boolean {
    return this.panels && this.panels.some(p => !p.isFloating);
  }

  onMinimizePanel(indexOrId: any) {
    const panelsCopy: PlanningPanelModel[] = angular.copy(this.panels);
    const index = this._getPanelIndex(indexOrId, panelsCopy);
    if (index === -1) return;
    const panel = panelsCopy[index];
    if (!panel) return;

    if (panel.isFloating) {
      panel.isMinimized = true;
      this.panels = panelsCopy;
      this._updateViewSettings();
    } else {
      const minimizedPanelsCopy: PlanningPanelModel[] = angular.copy(this.minimizedPanels);
      panel.isMinimized = true;

      panelsCopy.splice(index, 1);
      minimizedPanelsCopy.push(panel);

      this.panels = panelsCopy;
      this.minimizedPanels = minimizedPanelsCopy;

      if (!this.isMapToggled) {
        this.showMap = !(this.panels?.length >= 3 && !this.isBigScreen);
      }

      this._updateViewSettings();

      this.$timeout(() => {
        this.calculateVisibleMinimizedPanelsCount();
      }, 0);
    }
  }

  onChangeJobsGroupByType(jobsGroupByType, indexOrId: any) {
    const panelsCopy: PlanningPanelModel[] = angular.copy(this.panels);
    const index = this._getPanelIndex(indexOrId, panelsCopy);
    if (index > -1 && panelsCopy[index]) {
      panelsCopy[index].jobsGroupByType = jobsGroupByType;
      this.panels = panelsCopy;
      this._updateViewSettings();
    }
  }

  onMaximizePanel(indexOrId: any) {
    const panelsCopy: PlanningPanelModel[] = angular.copy(this.panels);
    const minimizedPanelsCopy: PlanningPanelModel[] = angular.copy(this.minimizedPanels);

    const index = this._getPanelIndex(indexOrId, minimizedPanelsCopy);
    if (index > -1 && minimizedPanelsCopy[index]) {
      const panel = minimizedPanelsCopy[index];
      panel.isMinimized = false;

      minimizedPanelsCopy.splice(index, 1);
      panelsCopy.push(panel);

      this.panels = panelsCopy;
      this.minimizedPanels = minimizedPanelsCopy;

      if (!this.isMapToggled) {
        this.showMap = !(this.panels?.length >= 3 && !this.isBigScreen);
      }

      this.showMap = this.panels?.length >= 3 && !this.isBigScreen ? false : true;

      this._updateViewSettings();

      this.$timeout(() => {
        this.calculateVisibleMinimizedPanelsCount();
      }, 0);
    }
  }

  onCloseHiddenMinimizedPanels() {
    if (this.minimizedPanels.length > this.visibleMinimizedPanelsCount) {
      this.minimizedPanels = this.minimizedPanels.slice(0, this.visibleMinimizedPanelsCount);

      this.$timeout(() => {
        this.calculateVisibleMinimizedPanelsCount();
      }, 0);
    }
    this.isMorePanelsDropdownOpen = false;
    this._updateViewSettings();
  }

  onToggleMorePanelsDropdown() {
    this.isMorePanelsDropdownOpen = !this.isMorePanelsDropdownOpen;
  }

  calculateVisibleMinimizedPanelsCount() {
    const mapContainer = document.querySelector('.map-container');
    const minimizedPanelsContainer = mapContainer ? mapContainer.querySelector('.minimized-panels-container') : null;
    const draftTotalsBar = document.querySelector('.draft-totals-bar');

    this.visibleMinimizedPanels = [];
    this.invisibleMinimizedPanels = [];

    if (!mapContainer || !minimizedPanelsContainer || this.minimizedPanels.length === 0) {
      this.visibleMinimizedPanelsCount = 0;
      return;
    }

    const mapContainerWidth = mapContainer.getBoundingClientRect().width;

    // Get the width of the draft-totals-bar and its right position
    let reservedSpace = 0;
    if (draftTotalsBar) {
      const draftTotalsBarWidth = draftTotalsBar.getBoundingClientRect().width;
      const rightPosition = 53; // From CSS: right: 53px
      reservedSpace = draftTotalsBarWidth + rightPosition;
    }

    const availableWidth = Math.max(0, mapContainerWidth - reservedSpace);

    const panelElement = minimizedPanelsContainer.querySelector('.minimized-panel');
    if (!panelElement) {
      this.visibleMinimizedPanelsCount = 0;
      return;
    }

    const panelWidth = panelElement.getBoundingClientRect().width + 5; // 5px for gap
    const morePanelsBox = document.querySelector('.more-panels-box');
    const morePanelsBoxWidth = morePanelsBox?.getBoundingClientRect().width || 0;


    let maxPanels = Math.floor(availableWidth / panelWidth);

    if (maxPanels < this.minimizedPanels.length) {
      maxPanels = Math.floor((availableWidth - morePanelsBoxWidth) / panelWidth);
    }

    this.visibleMinimizedPanelsCount = Math.max(0, Math.min(maxPanels, this.minimizedPanels.length));
    this.visibleMinimizedPanels = this.minimizedPanels.slice(0, this.visibleMinimizedPanelsCount);
    this.invisibleMinimizedPanels = this.minimizedPanels.slice(this.visibleMinimizedPanelsCount);


    this.$timeout(() => {
    }, 0);
  }

  onCompareDrafts() {
    this.planningDraftsService.getDrafts(this.project.draftsIds, this.project.id)
      .then((drafts) => {
        return this.planningDialogService.compareDrafts(drafts, this.project.selectedDraftId, this.viewConfiguration);
      })
      .then((selectedDraftId) => {
        if (!selectedDraftId) {
          this.$log.info('Dialog Closed');
        } else {
          this.setSelectedDraftInProject(selectedDraftId);
        }
      })
      .catch(() => {
        this.$log.info('Dialog Closed');
      })
  }

  onToggleDraftOverview() {
    this.selectedOverviewType = this.selectedOverviewType === 'draft' ? undefined : 'draft';
  }

  onQueryChanged(query) {
    this.filterConfig.queryString = query;
  }

  onToggleShowMap() {
    this.showMap = !this.showMap;

    if (!this.showMap) {
      this.timelineEnabled = false;
      if (!this.showPanels) {
        this.showPanels = true;
      }
    }

    this.isMapToggled = true;
    this._updateViewSettings();
    this.$timeout(() => {
      this.initMapContainerResizeObserver();
      this.calculateVisibleMinimizedPanelsCount();
    }, 0);
    this.resizeService.resize();
  }

  onToggleShowPanels() {
    this.showPanels = !this.showPanels;

    if (!this.showPanels) {
      if (!this.showMap) {
        this.showMap = true;
        this.isMapToggled = true;
      }
    }

    this._updateViewSettings();
    this.$timeout(() => {
      this.initMapContainerResizeObserver();
      this.calculateVisibleMinimizedPanelsCount();
    }, 0);
    this.resizeService.resize();
  }

  constrainTablePanelsWidth() {
    const dockedPanelsCount = this.panels?.filter(p => !p.isFloating).length ?? 0;
    const minWidth: number = MIN_PANEL_WIDTH * dockedPanelsCount;
    const maxWidth: number = MIN_PANEL_WIDTH * MAX_DOCKED_PANEL;

    this.tablePanelsWidth = Math.max(minWidth, Math.min(this.tablePanelsWidth, maxWidth));

    if (this.tablePanelsWidth > this.$window.innerWidth) {
      this.tablePanelsWidth = Math.max(0, this.$window.innerWidth - 100);
    }
  }

  onToggleViewMode(mode: PlanningViewMode) {
    this.viewMode = mode;
    if (mode === PlanningViewMode.CARDS) {
      const allPanels = _.concat(this.panels, this.minimizedPanels);
      this.panels = allPanels.filter(p => !p.isMinimized);
      this.minimizedPanels = allPanels.filter(p => !!p.isMinimized);
    }
    const isMapOn = this.showMap;
    this.showMap = false;
    this.constrainTablePanelsWidth();
    this._updateViewSettings();
    this.$timeout(() => {
      this.initMapContainerResizeObserver();
      this.calculateVisibleMinimizedPanelsCount();
      this.showMap = isMapOn;
      this.$timeout(() => {
        this.resizeService.resize();
      }, 0);
    }, 200);
  }

  // onJobsFiltersChange(skills, serviceAreaIds, tagNames, resourceIds, inRoute, isPacked) {
  //   this.filterConfig.jobsSelectedSkills = skills;
  //   this.filterConfig.selectedServiceAreasIds = serviceAreaIds;
  //   this.filterConfig.jobsSelectedTagNames = tagNames;
  //   this.filterConfig.jobsSelectedResourceIds = resourceIds;
  //   this.filterConfig.jobsInRouteQuery = inRoute;
  //   this.filterConfig.jobsIsPackedQuery = isPacked;
  // }

  onSelectDraft(draftId) {
    this.$state.go('.', {draftId: draftId}, {notify: true, reload: false});
  }

  // onSortJobsSlaTypeChange(sortJobsSlaType) {
  //   this.sortJobsSlaType = sortJobsSlaType;
  //   this.jobs = this._getSortedJobs(this.jobs);
  // }


  onSelectedJobsChange(jobIds) {
    this.selectedJobIds = jobIds;
    this._setSelectedLeftoverIds(jobIds);
    // this.jobs = this._getSortedJobs(this.jobs);

    this.setSelectedJobs();
  }


  onSelectedRoutesChange(ids) {
    this.selectedRouteIds = ids;
  }

  onViewJob(payload: { jobs: any[], event?: any }) {
    const {jobs, event} = payload;

    if (jobs?.length > 0) {
      this.planningDialogService.viewJobs(jobs, event)
        .catch(() => {
          this.$log.info('Dialog Closed')
        })
    }
  }

  getJobsByIds(jobIds: string[]): any[] {
    return _.filter(this.jobs, (j) => _.includes(jobIds, j.id));
  }

  onAddJobs(includeIds) {
    this.planningDraftsService.updateDraftJobs(this.project.id, this.draft.id, includeIds, undefined)
      .then(() => {
        this._resetSelectedJobs();
      });
  }

  onRemoveJobs(excludeIds) {
    if (this._getLockedJobIds(excludeIds).length) {
      this.planningAlertsService.removeLockedJobInfo();
      return;
    }

    this.planningDraftsService.updateDraftJobs(this.project.id, this.draft.id, undefined, excludeIds)
      .then(() => {
        this._resetSelectedJobs();
      });
  }

  onMoveToLeftovers(jobIds) {
    const lockedJobIds = this._getLockedJobIds(jobIds);
    const confirm = lockedJobIds.length ?
      this.confirmDialogService.confirmWithValidation('Move Locked Job', 'PLANNING_MOVE_LOCKED_JOB_WARNING', {}, 'PLANNING_MOVE_LOCKED_JOB_CONFIRM').then(() => this._unlockJobs(lockedJobIds)) :
      this.confirmDialogService.confirm('Move To Leftovers', 'Are you sure you want to move this activity to leftovers?');

    confirm
      .then(() => {
        const jobRoutes = _.filter(this.routes, (r) => {
          return (_.intersection(r.jobIds, jobIds)).length > 0;
        })

        const payloads = _.map(jobRoutes, (route) => {
          return {id: route.id, remove: _.intersectionWith(route.jobIds, jobIds, _.isEqual)}
        })

        this.onRemoveActivitiesFromRoutes(payloads);
      })
      .catch(() => {
        this.$log.info('Dialog Closed');
      })
  }

  onToggleLockJobs(jobIds: string[], isLocked: boolean) {
    if (isLocked) {
      this._lockJobs(jobIds).catch((error) => this.$log.error(error));
    } else {
      this._unlockJobs(jobIds).catch((error) => this.$log.error(error));
    }
  }

  private _lockJobs(jobIds: string[]) {
    const jobIdsByRouteId = this._getJobIdsByRouteId(jobIds);
    return this.planningDraftsService.lockJobs(this.project.id, this.draft.id, jobIdsByRouteId)
      .then(() => {
        this._setJobsLocked(jobIdsByRouteId);
        this._resetSelectedJobs();
      });
  }

  private _unlockJobs(jobIds: string[]) {
    const lockedJobIds = this._getLockedJobIds(jobIds);
    return this.planningDraftsService.unlockJobs(this.project.id, this.draft.id, lockedJobIds)
      .then(() => {
        this._setJobsUnlocked(lockedJobIds);
        this._resetSelectedJobs();
      });
  }

  private _getJobIdsByRouteId(jobIds: string[]): Record<string, string[]> {
    return _.chain(this.routes)
      .filter((r) => (_.intersection(r.jobIds, jobIds)).length > 0)
      .keyBy('id')
      .mapValues((r) => _.intersection(r.jobIds, jobIds))
      .value();
  }

  private _getLockedJobIds(jobIds: string[]): string[] {
    return _.chain(this.jobs)
      .filter((j) => !!j.lockedRouteId && _.includes(jobIds, j.id))
      .map('id')
      .value();
  }

  private _setJobsLocked(jobIdsByRouteId: Record<string, string[]>) {
    const jobsCopy = angular.copy(this.jobs);
    _.forEach(jobIdsByRouteId, (ids, routeId) => {
      _.forEach(jobsCopy, (j) => {
        if (_.includes(ids, j.id)) {
          j.lockedRouteId = routeId;
        }
      })
    })
    this.jobs = jobsCopy;
  }

  private _setJobsUnlocked(jobIds: string[]) {
    const jobsCopy = angular.copy(this.jobs);
    _.forEach(jobsCopy, (j) => {
      if (_.includes(jobIds, j.id)) {
        j.lockedRouteId = null;
      }
    })
    this.jobs = jobsCopy;
  }

  // Resources

  onResourcesFiltersChange(skills, serviceAreaIds, inRoute) {
    this.filterConfig.resourcesSelectedSkills = skills;
    this.filterConfig.selectedServiceAreasIds = serviceAreaIds;
    this.filterConfig.resourcesInRouteQuery = inRoute;
  }

  onSelectedResourcesChange(ids) {
    this.selectedResourceIds = ids;
    // this.resources = this._getSortedResources(this.resources);
  }

  onAddResources(ids) {
    this.planningDraftsService.updateDraftResources(this.project.id, this.draft.id, ids, undefined)
      .then(() => {
        this.selectedResourceIds = [];
      });
  }

  onRemoveResources(ids) {
    this.planningDraftsService.updateDraftResources(this.project.id, this.draft.id, undefined, ids)
      .then(() => {
        this.selectedResourceIds = [];
      });
  }

  // Draft

  // onSetSelectedDraftInProject() {
  //   if (this.project.selectedDraftId !== this.draft.id) {
  //     this.planningProjectsService.setSelectedDraft(this.project.id, this.draft.id)
  //       .then((selectedDraft) => {
  //         this.project.selectedDraftId = selectedDraft.id;
  //       })
  //   }
  // }

  onToggleGroupedRoutes() {
    this.isGroupedRoutes = !this.isGroupedRoutes;
    this._getDraftRoutes()
      .then((updatedRoutes: any) => {
        this.routes = this._getSortedRoutes(updatedRoutes);
        this._updateDraftJobs(this.draft);
      })
  }


  onExportDraftSvg(exportType) {
    this.planningDraftsService.exportDraft(this.project.id, this.draft.id, exportType);
  }

  onExportDraftRoutesLoadingSheetSvg(routeIds?) {
    this.planningDialogService.exportDraftLoadingSheet()
      .then((email?) => {
        this._exportDraftRoutesLoadingSheetSvg(routeIds, email);
      })
      .catch(() => {
        this.$log.info('Dialog Closed')
      })
  }

  onEditDraftSettings(event) {
    if (!!this.draft.draftTemplateId) {
      // this.planningTemplateDefaultDraftService.getDefaultDraftTemplates([this.draft.draftTemplateId])
      //   .then((draftTemplates: any) => {
      //     const draftCopy = angular.copy(this.draft);
      //     draftCopy.settings = angular.copy(draftTemplates[0].settings);
      //     this._editDraftSettings(draftCopy, draftTemplates[0], event);
      //   })

      this.$planningTemplatesDefaultDraft().$asyncValues([this.draft.draftTemplateId])
        .then((draftTemplates: any[]) => {
          const draftCopy = angular.copy(this.draft);
          draftCopy.settings = angular.copy(draftTemplates[0].settings);
          this._editDraftSettings(draftCopy, draftTemplates[0], event);
        });
    } else {
      this._editDraftSettings(this.draft, undefined, event);
    }
  }

  private _editDraftSettings(draft, draftTemplate, event) {
    this.planningDialogService.editDraftSettings(this.project, this.draft, draftTemplate, this.depots, event, (clusteringAreas) => {
      this.onClusteringAreasUpdated(clusteringAreas);
    })
      .then((payload: { draft: Object, doReoptimize: boolean }) => {
        const draftCopy = angular.copy(payload.draft);

        if (!!payload.doReoptimize) {
          this._updateDraftAndReoptimize(draftCopy);
        } else {
          this._updateDraft(draftCopy);
        }

        // this._updateDraftSettings(editedSettings);
      })
      .catch(() => {
        this.$log.info('Dialog Closed')
      })
  }

  onOpenDraftJobChanges(event) {
    const state = this.draft.jobChangesSyncState;

    if (state === DraftJobChangesSyncState.SCANNING || state === DraftJobChangesSyncState.APPLYING) {
      this.planningDialogService.draftJobChangesProcessingDialog(this.project, this.draft, event)
        .then(() => this.planningDialogService.onViewDraftJobChanges(this.project, this.draft, event));
      return;
    }

    if (!state) {
      this.planningDialogService.draftJobChangesProcessingDialog(this.project, this.draft, event, 'scan')
        .then(() => this.planningDialogService.onViewDraftJobChanges(this.project, this.draft, event));
      return;
    }

    this.planningDialogService.onViewDraftJobChanges(this.project, this.draft, event);
  }

  onDeleteDraft(event) {
    this.confirmDialogService.confirm('Delete Draft', 'Are you sure you want to delete draft?', event)
      .then(() => {
        this._deleteDraft();
      })
      .catch(() => {
        this.$log.info('Dialog Closed');
      })
  }

  onApproveAndDispatchDraft($event) {
    this.planningDialogService.approveAndDispatch($event)
      .then((payload) => {
        this._approveAndDispatch(this.draft.id, payload.dispatchLeftovers, payload.autoAssignRoutes, payload.keepProjectOpen);
      })
      .catch(() => {
        this.$log.info('Dialog Closed');
      })
  }

  onOptimizeDraft(event) {
    this.planningDialogService.draftOptimizingLoader(true, this.project.id, this.draft);
    this.planningDraftsService.optimizeDraft(this.draft.id, this.project);
  }

  onDuplicateDraft(event: any) {
    this.isDuplicateDraftDisabled = true;
    this.planningDraftsService.duplicateDraft(this.draft.id, this.project.id)
      .then((duplicatedDraft: any) => {
        this.$state.go('.', {draftId: duplicatedDraft.id}, {notify: true, reload: true});
      })
      .finally(() => {
        this.isDuplicateDraftDisabled = false;
      });
  }

  onCreateRouteByJobs(jobIds, $event) {
    this.planningDraftsService.getResources(this.project.id, this.draft.id, true)
      .catch((err) => {
        this.planningAlertsService.getResourcesError();
        return this.$q.reject(err);
      })
      .then((availableResources) => this.planningDialogService.createRouteToDraft(availableResources, this.selectedJobs, this.project.id, $event))
      .then((payload) => {
        const proceed = () => {
          if (payload.isExistingResource) {
            this._createRouteToDraft(payload.resource.id, jobIds, payload.routeName, undefined, undefined, hasSkillMismatch);
            this._resetSelectedJobs();
          } else {
            this.planningDraftsService.createDraftResources(this.project.id, this.draft.id, [payload.resource])
              .then((draftResources: any[]) => {
                this.resources = this.resources.concat(draftResources);
                this._createRouteToDraft(draftResources[0].id, jobIds, payload.routeName, undefined, undefined, hasSkillMismatch);
                this._resetSelectedJobs();
              })
          }
        };

        const warnings: { message: string, type?: string, data?: any }[] = this.planningDialogService.getJobsSkillMismatchWarnings(this.selectedJobs, payload.resource);
        const hasSkillMismatch = warnings.some((w) => w.type === 'skillMismatch');

        if (warnings.length) {
          this.planningDialogService.openJobAssignWarnings(warnings, $event)
            .then(() => {
              proceed();
            });
        } else {
          proceed();
        }
      })
      .catch((err) => {
        this.$log.info('Dialog Closed', err)
      })

    // if (!availableResources.length) {
    //   this.planningAlertsService.noAvailableResourcesInfo();
    // } else {
    //   this.planningDialogService.createRouteToDraft(availableResources, this.selectedJobs, $event)
    //     .then((payload) => {
    //       this._createRouteToDraft(payload.resource.id, jobIds);
    //       this._resetSelectedJobs();
    //     })
    //     .catch((err) => {
    //       this.$log.info('Dialog Closed', err)
    //     })
    // }

  }


  onUpdateRouteByJobs(jobIds, $event) {
    const matchedRoutes = this.routes;

    if (!matchedRoutes.length) {
      this.planningAlertsService.noAvailableResourcesInfo(); // TODO CHANGE TO NO ROUTES AVAILABLE
    } else {
      // var hasLeftovers = !!ctrl.leftoverJobs.length;
      this.planningDialogService.updateRouteToDraft(matchedRoutes, this.selectedJobs, this.draft.settings.considerVehicleTypes, $event)
        .then((payload) => {
          // payload - optimize/route
          const warnings: { message: string, type?: string, data?: any }[] = this.planningDialogService.getJobsSkillMismatchWarnings(this.selectedJobs, payload.route.resource);
          warnings.push(...this.planningDialogService.getJobsCapacityWarnings(this.selectedJobs, payload.route));
          const hasSkillMismatch = warnings.some((w) => w.type === 'skillMismatch');

          if (warnings.length) {
            this.planningDialogService.openJobAssignWarnings(warnings, $event)
              .then(() => {
                this._updateRouteByJobs(jobIds, payload, hasSkillMismatch);
              });
          } else {
            this._updateRouteByJobs(jobIds, payload, hasSkillMismatch);
          }
        })
        .catch((err) => {
          this.$log.info('Dialog Closed', err)
        })
    }
  }

  private _updateRouteByJobs(jobIds, payload, allowSkillsMismatch?: boolean) {
    const stopsToAdd = _.chain(this.jobs)
      .filter((j) => {
        return _.includes(jobIds, j.id);
      })
      .map('stops')
      .flatten()
      .value();

    const order = _.uniq(payload.route.stopsOrder.concat(_.map(stopsToAdd, 'id')));
    this.onAddStopsToRoute(payload.route.id, jobIds, order, payload.optimize, allowSkillsMismatch);
    this._resetSelectedJobs();
  }

  onCreateRouteByResource(resourceId, jobIds, stopIdOrder?, optimize?, allowSkillsMismatch?: boolean) {
    this._createRouteToDraft(resourceId, jobIds, undefined, stopIdOrder, optimize, allowSkillsMismatch);
  }


  // onViewRouteByResource(resource) {
  //   // this.selectedRouteToView = _.find(this.routes, (r) => {
  //   //   return _.get(r, 'resourceId') === resource.id;
  //   // });
  //   // this.selectedRouteToViewResource = this.resources.find((rs) => {
  //   //   return this.selectedRouteToView.resourceId === rs.id
  //   // })
  // }

  onViewRoute(routeId) {
    const panelsCopy = angular.copy(this.panels);

    if (panelsCopy.length) {
      panelsCopy[panelsCopy.length - 1].selectedTabIndex = 1;
      panelsCopy[panelsCopy.length - 1].selectedRouteId = routeId;
      this.panels = panelsCopy
    } else {
      this.onAddPanel(1, routeId)
    }

    this._updateViewSettings();
  }

  onZoomActivity(id) {
    this.zoomActivityId = id;
  }

  onActivityHighlight(activity?) {
    if (activity) {
      this.highlightedActivity = activity;
      this.selectedOverviewType = 'activity';
      this.highlightedActivityJobs = _.filter(this.jobs, (j) => {
        return _.includes(activity.jobIds || [activity.jobId], j.id)
      });
      this.highlightedActivityRoute = _.find(this.routes, (r) => {
        return r.id === activity.routeId;
      });
    } else {
      this.highlightedActivity = undefined;
      this.highlightedActivityJobs = undefined;
      this.highlightedActivityRoute = undefined;

      if (this.selectedOverviewType === 'activity') {
        this.selectedOverviewType = undefined;
      }
    }
  }

  onCloseViewRoute() {
    this.selectedRouteToViewResource = undefined;
  }

  onSaveDraftSettings(updatedSettings, name) {
    const draftCopy = angular.copy(this.draft);
    draftCopy.settings = updatedSettings;
    draftCopy.name = name;

    this._updateDraft(draftCopy);
  }

  onSaveAndReoptimizeDraftSettings(updatedSettings, name) {
    const draftCopy = angular.copy(this.draft);
    draftCopy.settings = updatedSettings;
    draftCopy.name = name;

    this._updateDraftAndReoptimize(draftCopy);
  }

  onRemoveActivitiesFromRoutes(payload) {
    this.planningDraftsService.moveActivityInRoutes(payload, this.project, this.draft.id, this.isGroupedRoutes)
      .then((updatedRoutes: any) => {
        const routes = _.unionBy(updatedRoutes, this.routes, 'id');
        this.routes = this._getSortedRoutes(routes);
        this._resetSelectedJobs();
        this.onActivityHighlight();
      })
  }

  // Map Interactions

  onRoutedJobSelect(jobId) {
    if (!_.includes(this.selectedJobIds, jobId)) {
      this.selectedJobIds = this.selectedJobIds.concat([jobId]);
    } else {
      this.selectedJobIds = _.filter(this.selectedJobIds, function (id) {
        return id !== jobId;
      })
    }
    // this.jobs = this._getSortedJobs(this.jobs);
    this.setSelectedJobs();


  }

  onHiddenRouteIdsChange(ids) {
    this.hiddenRouteIds = ids;
  }

  onMapLayersChange(layers: MapLayersSettings) {
    this.mapLayers = layers;
    this._updateViewSettingsDebounced();
  }

  onSelectRoute(routeId) {
    this.selectedRouteId = routeId;
  }

  // Timeline
  onToggleRouteDisplay(id, isEnabled) {
    if (isEnabled) {
      this.hiddenRouteIds = _.filter(this.hiddenRouteIds, (rid) => {
        return rid !== id;
      })
    } else {
      this.hiddenRouteIds = this.hiddenRouteIds.concat([id]);
    }
  }

  onAddStopsToRoute(routeId, jobIds, order, doOptimization, allowSkillsMismatch?: boolean) {
    const lockedJobIds = this._getLockedJobIds(jobIds);
    if (lockedJobIds.length) {
      this.confirmDialogService.confirmWithValidation('Move Locked Job', 'PLANNING_MOVE_LOCKED_JOB_WARNING', {}, 'PLANNING_MOVE_LOCKED_JOB_CONFIRM')
        .then(() => this._unlockJobs(lockedJobIds))
        .then(() => this.onAddStopsToRoute(routeId, jobIds, order, doOptimization, allowSkillsMismatch))
        .catch(() => this.$log.info('Dialog Closed'));
      return;
    }

    this.planningDraftsService.addStopsToRoute(routeId, jobIds, order, doOptimization, this.project, this.draft.id, allowSkillsMismatch)
      .then((updatedRoutes: any) => {
        const routes = _.unionBy(updatedRoutes, this.routes, 'id');
        this.routes = this._getSortedRoutes(routes);
      })
  }

  onRecalcRoute(routeId, ignoreSequence, event) {
    this.planningDraftsService.recalcRoutesInDraft(this.project, this.draft.id, [routeId], ignoreSequence)
      .then(() => {
        // this.planningDialogService.draftOptimizingLoader(true, this.project.id, this.draft);
      })
  }

  onRecalcRoutes(ids: string[], preserveJobs?: boolean) {
    this.planningDraftsService.recalcRoutesInDraft(this.project, this.draft.id, ids, undefined, preserveJobs)
      .then(() => {
        this.selectedRouteIds = [];
        // this.planningDialogService.draftOptimizingLoader(true, this.project.id, this.draft);
      })
  }

  onEditPickingTime(routeIds: string[]) {
    const selectedRoutes = _.filter(this.routes, (r) => _.includes(routeIds, r.id));
    this.planningDialogService.editPickingTime(selectedRoutes)
      .then((pickingTime) => {
        this._updateRoutesPickingTime(routeIds, pickingTime);
      })
      .catch(() => {
        this.$log.info('Edit picking time dialog cancelled');
      });
  }

  private _updateRoutesPickingTime(routeIds: string[], pickingTime: number) {
    this.planningDraftsService.updateRoutesPickingTime(this.project.id, this.draft.id, routeIds, pickingTime);

  }

  onPreAssignAgent(ids: string[]) {
    const selectedRoutes = _.filter(this.routes, (r) => _.includes(ids, r.id));
    let currentAgentId;
    if (selectedRoutes?.length === 1) {
      currentAgentId = selectedRoutes[0].resource.agentId;
    }

    this.planningDialogService.preAssignAgentToRoutes(selectedRoutes, currentAgentId)
      .then((agentId) => {
        if (agentId) {
          const routeIds = _.map(selectedRoutes, 'id');
          this._preAssignAgent(routeIds, agentId);
        }
      })
      .catch(() => {
        this.$log.info('Pre-assign agent dialog cancelled');
      });
  }

  private _preAssignAgent(routeIds: string[], agentId: string) {
    this.planningDraftsService.assignAgent(this.project.id, this.draft.id, routeIds, agentId)
      .then((updatedRoutes: any) => {
        const routes = _.unionBy(updatedRoutes, this.routes, 'id');
        this.routes = this._getSortedRoutes(routes);
        this.selectedRouteIds = [];
      })
  }

  onFeedback(routeId: string, feedback: 'LIKE' | 'DISLIKE' | 'NEUTRAL') {
    this.planningDraftsService.updateRouteFeedback(this.project.id, this.draft.id, routeId, { feedback })
      .then((updatedRoute: any) => {
        const routes = _.map(this.routes, (r) => {
          if (r.id === routeId) {
            return { ...r, feedback };
          }
          return r;
        });
        this.routes = this._getSortedRoutes(routes);
      });
  }

  onDeleteRoutes(routeIds: string[]) {
    const title = 'Delete Multiple Routes';
    const text = 'PLANNING_DRAFT_DELETE_ROUTES_WARNING';
    const dataObject = {x: routeIds.length};
    const textValidation = 'VALIDATE_CONFIRM_INFO';

    this.confirmDialogService.confirmWithValidation(title, text, dataObject, textValidation)
      .then(() => {
        this._deleteRoutes(routeIds);
      })
  }

  onLockRouteChange(id, locked) {
    this.planningDraftsService.updateRouteLockState(this.project.id, this.draft.id, id, !!locked)
      .then((updatedRoutes: any) => {
        const routesCopy = angular.copy(this.routes);
        const jobsCopy = angular.copy(this.jobs);
        const resourcesCopy = angular.copy(this.resources);
        const routeIndex = _.findIndex(routesCopy, (r) => {
          return r.id === id;
        })

        if (routeIndex > -1) {
          routesCopy[routeIndex].locked = !routesCopy[routeIndex].locked;
          routesCopy[routeIndex].updatedAt = this.moment().valueOf();

          const updatedJobIds = _.flatMap(routesCopy[routeIndex], 'jobIds');
          _.forEach(jobsCopy, (j) => {
            if (_.includes(updatedJobIds, j.id)) {
              j.locked = !locked;
            }
          })

          const updatedResourceIds = _.map(routesCopy[routeIndex], 'resource.id');
          _.forEach(resourcesCopy, (r) => {
            if (_.includes(updatedResourceIds, r.id)) {
              r.locked = !locked;
            }
          })

        }
        this.routes = routesCopy;
        this.jobs = jobsCopy;
        this.resources = resourcesCopy;

        this._resetSelectedJobs();
      })
  }

  onDispatchRoutes(ids) {
    this.planningDraftsService.approveAndDispatchRoutes(this.draft.id, this.project.id, ids)
      .then((res) => {
        this.selectedRouteIds = [];
        this.selectedResourceIds = [];
      })
  }

  onPrintRoutes(ids) {
    const routesSyncIds = _.chain(this.routes)
      .filter(r => {
        return _.includes(ids, r.id)
      })
      .map(filteredRoute => {
        return filteredRoute.syncId
      })
      .value();

    if (routesSyncIds.length) {
      this.selectedRouteIds = [];
      const siteId = this.splitService.getSiteId();
      const url = this.$state.href('print.routes', {syncIds: routesSyncIds, siteId: siteId});
      this.analyticsService.trackEvent('Routes Actions', 'Print Routes', 'Click');
      this.$window.open(url, '_blank', 'width=900,height=700,scrollbars=no,menubar=no,toolbar=no,location=no,status=no,titlebar=no');
    }
  }

  onPrintRoutesLoadingSheet(ids) {
    const routesSyncIds = _.chain(this.routes)
      .filter(r => {
        return _.includes(ids, r.id)
      })
      .map(filteredRoute => {
        return filteredRoute.syncId
      })
      .value();

    if (routesSyncIds.length) {
      this.selectedRouteIds = [];
      const siteId = this.splitService.getSiteId();
      const url = this.$state.href('print.loading-sheets', {
        syncIds: routesSyncIds,
        siteId: siteId
      });
      this.analyticsService.trackEvent('Routes Actions', 'Print Loading Sheet', 'Click');
      this.$window.open(url, '_blank', 'width=900,height=700,scrollbars=no,menubar=no,toolbar=no,location=no,status=no,titlebar=no');
    }
  }


  onMoveActivity(jobIds, fromRouteId, toRouteId, fromOrderedIds, toOrderedIds, pickupIndex?: number, destinationIndex?: number, sourceRouteJobs?: { routeId: string; jobIds: string[] }[], allowSkillsMismatch?: boolean) {
    // The jobs being moved can come from several routes, and the dragged one may itself already
    // sit on the target route - so the move is cross-route whenever a source route differs from it.
    const crossRouteSources = _.filter(sourceRouteJobs, (group) => group.routeId !== toRouteId);
    const isCrossRouteMove = fromRouteId !== toRouteId || !!crossRouteSources.length;

    const lockedJobIds = isCrossRouteMove ? this._getLockedJobIds(jobIds) : [];
    if (lockedJobIds.length) {
      this.confirmDialogService.confirmWithValidation('Move Locked Job', 'PLANNING_MOVE_LOCKED_JOB_WARNING', {}, 'PLANNING_MOVE_LOCKED_JOB_CONFIRM')
        .then(() => this._unlockJobs(lockedJobIds))
        .then(() => this.onMoveActivity(jobIds, fromRouteId, toRouteId, fromOrderedIds, toOrderedIds, pickupIndex, destinationIndex, sourceRouteJobs, allowSkillsMismatch))
        .catch(() => this.$log.info('Dialog Closed'));
      return;
    }

    if (isCrossRouteMove && (pickupIndex !== undefined || destinationIndex !== undefined)) {
      this.onAddJobsToPlanningRoute(toRouteId, jobIds, pickupIndex, destinationIndex, allowSkillsMismatch);
      return;
    }

    let payload;
    let sourceRouteIds: string[];
    if (crossRouteSources.length) {
      sourceRouteIds = _.map(crossRouteSources, 'routeId');
      payload = _.map(crossRouteSources, (group) => ({id: group.routeId, remove: group.jobIds}));
      payload.push({id: toRouteId, add: jobIds, order: toOrderedIds});
    } else {
      sourceRouteIds = _.compact([fromRouteId]);
      payload = this.TimelineService.getMovedTaskPayload(jobIds, fromRouteId, toRouteId, fromOrderedIds, toOrderedIds);
    }
    // PlanningDialogService.draftOptimizingLoader(true, ctrl.project.id, ctrl.draft.id);

    this.isLoading = true;
    this.planningDraftsService.moveActivityInRoutes(payload, this.project, this.draft.id, this.isGroupedRoutes, allowSkillsMismatch)
      .then((updatedRoutes: any) => {
        const routes = _.unionBy(updatedRoutes, this.routes, 'id');
        this.routes = this._getSortedRoutes(routes);
        this._resetSelectedJobs();
      })
      .catch(() => {
        const restoreRouteIds = _.compact(_.uniq([...sourceRouteIds, toRouteId]));
        if (restoreRouteIds?.length) {
          this._getDraftRoutes(restoreRouteIds)
            .then(this._refreshRoutes.bind(this))
            .catch((error) => this.$log.error(error));
        }
      })
      .finally(() => {
        this.isLoading = false;
      })
  }

  onAddJobsToPlanningRoute(routeId: string, jobIds: string[], pickupIndex?: number, destinationIndex?: number, allowSkillsMismatch?: boolean) {
    const payload: {
      routeId: string;
      jobIds: string[];
      pickupIndex?: number;
      destinationIndex?: number;
      optimize: boolean;
      allowSkillsMismatch?: boolean;
    } = { routeId, jobIds, optimize: false };

    if (Number.isSafeInteger(pickupIndex)) {
      payload.pickupIndex = pickupIndex;
    }

    if (Number.isSafeInteger(destinationIndex)) {
      payload.destinationIndex = destinationIndex;
    }

    if (allowSkillsMismatch) {
      payload.allowSkillsMismatch = true;
    }

    this.isLoading = true;
    this.planningDraftsService.addJobsToPlanningRoute(payload, this.project, this.draft.id, this.isGroupedRoutes)
      .then((updatedRoutes: any) => {
        const routes = _.unionBy(updatedRoutes, this.routes, 'id');
        this.routes = this._getSortedRoutes(routes);
        this._resetSelectedJobs();
      })
      .catch((error) => this.$log.error(error))
      .finally(() => {
        this.isLoading = false;
      });
  }

  onRemoveActivityFromRoute(routeId, jobIds) {
    const payload = [{id: routeId, remove: jobIds}];
    this.planningDraftsService.moveActivityInRoutes(payload, this.project, this.draft.id, this.isGroupedRoutes)
      .then((updatedRoutes: any) => {
        const routes = _.unionBy(updatedRoutes, this.routes, 'id');
        this.routes = this._getSortedRoutes(routes);
      })
  }

  onToggleTimeline() {
    this.timelineEnabled = !this.timelineEnabled;

    if (!this.timelineEnabled) {
      this.isTimelineFullScreen = false;
    }
  }

  onTimelineFullScreen() {
    this.isTimelineFullScreen = !this.isTimelineFullScreen;
    this.timelineEnabled = true;

    const timelineElement = document.getElementById('planning-timeline');
    const height = this.isTimelineFullScreen ? window.innerHeight : (window.innerHeight / 2);
    timelineElement.style.height = height + 'px';
  }

  // Leftovers
  onLeftOverJobSelect(jobId) {
    this.$log.info(jobId);
    if (!_.includes(this.selectedJobIds, jobId)) {
      this.selectedJobIds = this.selectedJobIds.concat([jobId]);
    } else {
      this.selectedJobIds = _.filter(this.selectedJobIds, function (id) {
        return id !== jobId;
      })
    }
    this._setSelectedLeftoverIds(this.selectedJobIds);
    // this.jobs = this._getSortedJobs(this.jobs);
    this.setSelectedJobs();
  }

  onLeftOverMultipleJobSelect(jobIds) {

    //If some are not selected yet select all of them else remove all of them.
    if (!!_.difference(jobIds, this.selectedJobIds).length) {
      this.selectedJobIds = _.uniq(_.concat(this.selectedJobIds, jobIds));
    } else {
      this.selectedJobIds = _.difference(this.selectedJobIds, jobIds);
    }

    this._setSelectedLeftoverIds(this.selectedJobIds);
    // this.jobs = this._getSortedJobs(this.jobs);
    this.setSelectedJobs();
  }

  setAllLeftOverSelection(isSelectAll) {
    this.selectedJobIds = isSelectAll ? _.map(this.leftoverJobs, 'id') : [];
    this._setSelectedLeftoverIds(this.selectedJobIds);
    this.setSelectedJobs();
  }

  onChangeResourceSequence(orderedRouteIds: string[], routeGroupId: string) {
    this.planningDraftsService.updateResourceSequence(this.project.id, this.draft.id, routeGroupId, orderedRouteIds)
      .then((res) => {

      })
  }

  onEditResourceAllocation(resource, routeId, $event) {
    this.planningDialogService.editDraftResourceAllocation(resource, routeId, $event)
      .then((updatedResource) => {
        return this.planningDraftsService.updateDraftResource(
          this.project.id,
          this.draft.id,
          resource.id,
          updatedResource
        );
      })
      .then((updatedResource) => {
        const index = this.resources.findIndex(r => r.id === updatedResource.id);
        if (index >= 0) {
          this.resources = _.map(this.resources, r => r.id === updatedResource.id ? updatedResource : r);
          // Properly refresh and sort the resources array to trigger change detection
          // this.resources = this._getSortedResources(this.resources);
          // Force Angular change detection
          this.$timeout(() => {
          });
        }
      })
      .catch((error) => {
        if (!error) {
          this.$log.info('Dialog cancelled');
        }
      });
  }

  onChangeRouteResource(routeId, $event) {
    const resourcesOptions = _.map(angular.copy(this.resources), (r) => {
      const resourceSource = _.get(r, 'source');
      const resourceName = resourceSource === 'AgentSchedule' ? _.get(r, 'agentName')
        : (_.get(r, 'allocationName') || _.get(r, 'vehicleName', '---'));

      r.allocationName = resourceName;
      return r;
    });

    const data = {
      optionsWrapper: {
        list: resourcesOptions,
        propertyRef: 'allocationName',
        skills: 'allocationSkills'
      }
    };
    const routeRef = _.find(this.routes, (r) => {
      return r.id === routeId;
    });
    const currentResourceId = routeRef?.resource?.id;
    const routeName = routeRef?.name;
    const pickingTimeOffsetInMinutes = routeRef?.pickingTimeOffsetInMinutes;
    const routeColor = routeRef?.color;

    // const routeEta: this.moment(activity.eta),
    //   end: this.moment(route.activities[index + 1].eta),
    // const pickingTimeOffsetInMinutes = routeRef?.pickingTimeOffsetInMinutes ?

    this.editRouteResourceNamePanelService.open($event, data, routeRef, currentResourceId, routeName, routeColor, pickingTimeOffsetInMinutes,
      (updatedResourceId?: string, updatedRouteName?: string, updatedRouteColor?: string, updatedPickingTimeOffsetInMinutes?: number) => {
        if (!!updatedRouteName && routeName !== updatedRouteName) {
          this._updateRouteName(routeRef.id, updatedRouteName);
        }
        if (!!updatedResourceId && (currentResourceId !== updatedResourceId)) {
          this.updateRouteResource(routeRef, updatedResourceId);
        }

        if (!!updatedRouteColor && routeColor !== updatedRouteColor) {
          this._updateRouteColor(routeRef.id, updatedRouteColor);
        }

        if (!_.isUndefined(updatedPickingTimeOffsetInMinutes) && (pickingTimeOffsetInMinutes !== updatedPickingTimeOffsetInMinutes)) {
          this._updateRoutePickingTimeOffset(routeRef.id, updatedPickingTimeOffsetInMinutes);
        }

      });
  }

  private _updateViewSettingsDebounced() {
    if (this._pendingViewSettingsUpdate) {
      this.$timeout.cancel(this._pendingViewSettingsUpdate);
    }

    this._pendingViewSettingsUpdate = this.$timeout(() => {
      this._pendingViewSettingsUpdate = undefined;
      this._updateViewSettings();
    }, 500);
  }

  private _flushViewSettingsUpdate() {
    if (this._pendingViewSettingsUpdate) {
      this.$timeout.cancel(this._pendingViewSettingsUpdate);
      this._pendingViewSettingsUpdate = undefined;
      this._updateViewSettings();
    }
  }

  private _updateViewSettings() {
    const panels: PlanningPanelModel[] = _.concat(this.panels, this.minimizedPanels);

    if (this.viewSettings?.id) {
      const viewTableSettingsCopy = {
        ...this.viewSettings,
        settings: {
          ...this.viewSettings.settings,
          panels: panels,
          viewMode: this.viewMode,
          showMap: this.showMap,
          showPanels: this.showPanels,
          tablePanelsWidth: this.tablePanelsWidth,
          mapLayers: this.mapLayers
        }
      };
      viewTableSettingsCopy.holderType = ViewSettingsHolderType.User;

      this.viewSettingsService.updateByUser(this.viewSettings.id, viewTableSettingsCopy)
        .then((viewSettingsTable: ViewSettingsModel) => {
          this.viewSettings = viewSettingsTable;
        });

    } else {
      const viewTableSettings = {
        pageName: `planning.draft-${this.draft.id}`,
        holderType: ViewSettingsHolderType.User,
        settingsType: ViewSettingsType.DraftPanels,
        settings: {
          panels: panels,
          viewMode: this.viewMode,
          showMap: this.showMap,
          showPanels: this.showPanels,
          tablePanelsWidth: this.tablePanelsWidth,
          mapLayers: this.mapLayers
        }
      }
      this.viewSettingsService.createByUser(viewTableSettings)
        .then((viewSettingsTable: ViewSettingsModel) => {
          this.viewSettings = viewSettingsTable;
        });
    }
  }

  private _updateViewConfigurations() {
    const viewConfiguration: PlanningViewSettingsModel = this.viewConfiguration;

    if (this.viewSettingsColumns?.id) {
      const viewTableSettingsCopy = {
        ...this.viewSettingsColumns,
        settings: {viewConfiguration: viewConfiguration}
      };
      viewTableSettingsCopy.holderType = ViewSettingsHolderType.User;

      this.viewSettingsService.updateByUser(this.viewSettingsColumns.id, viewTableSettingsCopy)
        .then((viewSettingsColumns: ViewSettingsModel) => {
          this.viewSettingsColumns = viewSettingsColumns
        })

    } else {
      const viewTableSettings = {
        pageName: `planning.project`,
        holderType: ViewSettingsHolderType.User,
        settingsType: ViewSettingsType.DraftPanels,
        settings: {
          viewConfiguration: viewConfiguration
        }
      }
      this.viewSettingsService.createByUser(viewTableSettings)
        .then((viewSettingsColumns: ViewSettingsModel) => {
          this.viewSettingsColumns = viewSettingsColumns;
        })
    }
  }

  onViewConfigurationChange(viewConfiguration: PlanningViewSettingsModel) {
    this.viewConfiguration = viewConfiguration;
    // this.viewSettings.settings = settings;
    this._updateViewConfigurations();
  }

  // onCompareDrafts() {
  //   // if (!draftIds || !draftIds.length) {
  //   //   draftIds = this.draftIds;
  //   // }
  //   this.planningDraftsService.getDrafts(this.project.draftIds, this.project.id)
  //     .then((drafts) => {
  //       return this.planningDialogService.compareDrafts(drafts, this.project.selectedDraftId);
  //     })
  //     .then((selectedDraftId) => {
  //       if (!selectedDraftId) {
  //         this.$log.info('Dialog Closed');
  //       } else {
  //         this.setSelectedDraftInProject(selectedDraftId);
  //       }
  //     })
  //     .catch(() => {
  //       this.$log.info('Dialog Closed');
  //     })
  // }


  getRouteColor(routeId: string) {
    const route = this.routes.find((r) => r.id === routeId);
    if (!!route) {
      return this.planningCommonService.getRouteColor(route);
    }
  }

  getRouteServicesCount(routeId: string) {
    const route = this.routes.find((r) => r.id === routeId);
    if (!!route) {
      return route.jobIds?.length || 0;
    }
  }

  panelHasFilters(panel) {
    let hasFilters = false;
    _.forOwn(panel.filterConfig, (value, key) => {
      if (_.isArray(value) ? !!value.length : !_.isUndefined(value)) {
        hasFilters = true;
        return false;
      }
    })

    return hasFilters;
  }


  onToggleObligateTimeWindow(jobIds: string[], obligateTimeWindow: boolean) {
    this.planningProjectsService.toggleObligateTimeWindow(this.project.id, this.draft.id, jobIds, obligateTimeWindow)
      .then((jobs: any[]) => {
        const jobsCopy = angular.copy(this.jobs);
        jobs.forEach((j => {
          const jobIndex = this.jobs.findIndex((job) => job.id === j.id);
          jobsCopy[jobIndex] = j;
        }))
        this.jobs = jobsCopy;
      });
  }

  onOpenRoutePanelsByIds(routeIds: string[]) {
    routeIds.forEach(routeId => this._addPanel(1, routeId));
    this.hiddenRouteIds = _.difference(_.map(this.routes, 'id'), routeIds);
    this._commitPanelsChange();
  }

  // ******************************
  //        Private methods
  // ******************************

  private setSelectedDraftInProject(draftId: string) {
    if (this.project.selectedDraftId !== draftId) {
      this.planningProjectsService.setSelectedDraft(this.project.id, draftId)
        .then((selectedDraft: any) => {
          this.project.selectedDraftId = selectedDraft.id;
        })
    }
  }


  private _bindDraftEventListener() {
    this.draftRef = this.$drafts(this.draft.id);
    this.draftRef.$bindCtrl(this.$scope, this, 'draftLive_', {projectId: this.draft.projectId});
    this.draftRef.$registerOnUpdateHandler(this, (updatedDraft) => {

      if (_.isEqual(this.draft.id, updatedDraft.id) &&
        !_.isEqual(this.draft.updatedAt, updatedDraft.updatedAt)) {
        this._setDraftData(updatedDraft);
      }

    })
  }

  private _bindDraftRoutesEventListener() {
    this.draftRoutesRef.$subscribeChannel(this, (routes) => {
      const currentRouteIds = _.map(this.routes, 'id');
      const routesToUpdate = _.filter(routes, (r) => {
        if (!_.isEqual(r.draftId, this.draft.id) || !_.includes(currentRouteIds, r.id)) {
          return false
        } else {
          var routeRef = _.find(this.routes, (route) => {
            return route.id === r.id;
          })
          return routeRef && r.updatedAt > routeRef.updatedAt;
        }
      })

      this.$log.info('Draft View Routes:', routes);

      if (routesToUpdate.length) {
        const routeIdsToFetch = _.difference(_.map(routesToUpdate, 'id'), this.currentlyFetchingRouteIds);

        if (routeIdsToFetch.length) {
          this.currentlyFetchingRouteIds = _.uniq(_.concat(routeIdsToFetch, this.currentlyFetchingRouteIds))

          this._getDraftRoutes(routeIdsToFetch)
            .then((updatedRoutes: any) => {
              this._refreshRoutes(updatedRoutes);
              this.currentlyFetchingRouteIds = _.difference(this.currentlyFetchingRouteIds, routeIdsToFetch);
            })
        }
      }

    })
  }

  private _setDraftData(updatedDraft) {
    // jobChangesSyncStateAt is written on every jobChangesSyncState transition (SCANNING,
    // CHANGES_READY, APPLYING, SYNCED, FAILED), not only a successful apply — so also require the
    // state itself to be SYNCED, otherwise a bare "scan just started" push would trigger this too.
    // A newer jobChangesSyncStateAt than what we already had means this SYNCED transition happened
    // since we last saw the draft — the jobs an apply wrote are now stale in memory, so re-fetch
    // them. Guard the "no previous value" case (never synced before) by treating a missing
    // previous timestamp as epoch, so the very first sync is still caught rather than silently
    // skipped by a NaN comparison.
    const previousJobChangesSyncStateAt = this.draft?.jobChangesSyncStateAt;
    const updatedJobChangesSyncStateAt = updatedDraft?.jobChangesSyncStateAt;
    if (updatedDraft?.jobChangesSyncState === DraftJobChangesSyncState.SYNCED &&
      updatedJobChangesSyncStateAt && updatedJobChangesSyncStateAt !== previousJobChangesSyncStateAt &&
      new Date(updatedJobChangesSyncStateAt).getTime() > new Date(previousJobChangesSyncStateAt || 0).getTime()) {
      this._getJobs();
    }

    this.draft = updatedDraft;

    this.$log.info('Draft View:', updatedDraft);

    // Draft Statuses - SCHEME/IN_PROGRESS/OPTIMIZED/COMPLETED
    if (updatedDraft.status === 'IN_PROGRESS') {
      this.planningDialogService.draftOptimizingLoader(true, this.project.id, updatedDraft);//TODO ask liron if i can pass 3/4 params
    }

    if (updatedDraft.status === 'OPTIMIZED' || updatedDraft.status === 'SCHEME') {
      this.planningDialogService.draftOptimizingLoader(false);

      //check if jobs changed, change the routed/excluded and set it as needed to be updated.
      this._updateDraftJobs(updatedDraft);
      this._updateDraftResources(updatedDraft, this.resources);

      this._setDraftRoutes(updatedDraft);
      this._setDraftAnalysis();
      this._setLeftoversByJobIds(updatedDraft.leftoversIds);
      this._loadClusteringAreasForMap();
    }
  }

  private _setSelectedLeftoverIds(selectedJobIds) {
    const leftoverJobsIds = _.map(this.leftoverJobs, 'id');
    this.selectedLeftoverIds = _.filter(selectedJobIds, (id) => {
      return _.includes(leftoverJobsIds, id);
    })
  }

  private _setServiceAreasByJobs(jobs) {
    if (this.project.snapshot) {
      return;
    }

    const areaIds = _.chain(jobs)
      .map('areaIds')
      .flatten()
      .uniq()
      .value();

    if (areaIds.length) {
      this.serviceAreasRef.$asyncValues(areaIds)
        .then((serviceAreas) => {
          this.serviceAreas = _.uniqBy(this.serviceAreas.concat(serviceAreas), 'areaId');
        })
    }
  }

  private _loadClusteringAreasForMap() {
    const ownerId = this.draft?.id;
    const areaIds = this.draft?.clusteringAreaIds || [];
    const idsKey = _.sortBy(areaIds).join(',');

    if (this.loadedClusteringAreaIdsKey === idsKey) {
      return;
    }

    this.loadedClusteringAreaIdsKey = idsKey;

    if (!ownerId || !areaIds.length || this.project.snapshot) {
      this.clusteringAreas = [];
      return;
    }

    this.planningClusteringAreasRequestsService.getClusteringAreasForMap(ownerId, areaIds)
      .then((areas) => {
        const currentKey = _.sortBy(this.draft?.clusteringAreaIds || []).join(',');
        if (currentKey !== idsKey) {
          return;
        }

        this.clusteringAreas = areas;
      })
      .catch((error) => {
        this.$log.error('Failed to load clustering areas for map', error);
        this.clusteringAreas = [];
      });
  }

  onClusteringAreasUpdated(clusteringAreas) {
    this.clusteringAreas = angular.copy(clusteringAreas || []);
  }

  _getSortedResources(resources) {
    const routedResources = [];
    const unRoutedResources = [];
    const excludedResources = [];

    _.forEach(resources, (r) => {

      r.routeId = undefined;

      if (r.routed) {
        const route = _.find(this.routes, (route) => {
          return _.isEqual(route.resourceId, r.id);
        })
        if (route) {
          _.set(r, 'routeId', route.id);
          _.set(r, 'locked', route.locked);
        }
        routedResources.push(r);
      }
      if (!r.routed && !r.excluded) {
        unRoutedResources.push(r);
      }
      if (r.excluded) {
        excludedResources.push(r);
      }
    })

    const sortedResources = _.concat(routedResources, unRoutedResources, excludedResources);

    // all the selected resources will be on top
    const selectedResources = _.filter(sortedResources, (r) => {
      return _.includes(this.selectedResourceIds, r.id);
    })
    const unselectedResources = _.filter(sortedResources, (r) => {
      return !_.includes(this.selectedResourceIds, r.id);
    })
    return _.concat(selectedResources, unselectedResources);

    // // return _.orderBy(resources, ['routed', 'excluded'], ['desc', 'desc']);
    // return _.concat(routedResources, unRoutedResources, excludedResources);
  }

  private _setDraftRoutes(draft) {
    const currentRouteIds = _.map(this.routes, 'id');

    const routeIdsToRemove = _.difference(currentRouteIds, draft.routesIds);
    let routeIdsToAdd = _.difference(draft.routesIds, currentRouteIds);
    routeIdsToAdd = _.difference(routeIdsToAdd, this.currentlyFetchingRouteIds)

    const isInitialLoad = this.isInitialRoutesLoad;
    this.isInitialRoutesLoad = false;

    if (routeIdsToRemove.length) {
      this.routes = _.filter(this.routes, (r) => {
        return !_.includes(routeIdsToRemove, r.id)
      })
      this.hiddenRouteIds = _.difference(this.hiddenRouteIds, routeIdsToRemove);
    }

    if (routeIdsToAdd.length) {
      this.currentlyFetchingRouteIds = _.uniq(_.concat(routeIdsToAdd, this.currentlyFetchingRouteIds));

      const chunks = _.chunk(routeIdsToAdd, 50);
      const promises = chunks.map(chunk => this._getDraftRoutes(chunk));

      this.$q.all(promises)
        .then((results: any[]) => {
          this.currentlyFetchingRouteIds = _.difference(this.currentlyFetchingRouteIds, routeIdsToAdd);

          const fetchedRoutes = _.flatten(results);
          const draftRouteIds = this.draft?.routesIds;
          const routesToAdd = _.isArray(draftRouteIds) ?
            _.filter(fetchedRoutes, (r) => _.includes(draftRouteIds, r.id)) :
            fetchedRoutes;
          const addedRouteIds = _.map(routesToAdd, 'id');
          // this.routes = _.uniqBy(this.routes.concat(routesToAdd), 'id');

          const routes = _.orderBy(_.uniqBy(this.routes.concat(routesToAdd), 'id'), ['resource.allocationName', 'resource.vehicleName'], ['asc']);
          this.routes = this._getSortedRoutes(routes);
          this._updateDraftJobs(this.draft);
          this._updateDraftResources(this.draft, this.resources);

          if (isInitialLoad || !!this.hiddenRouteIds.length) {
            this.hiddenRouteIds = _.union(this.hiddenRouteIds, addedRouteIds);
          }
        })
        .catch((error) => {
          this.currentlyFetchingRouteIds = _.difference(this.currentlyFetchingRouteIds, routeIdsToAdd);
          this.$log.error('Failed to fetch draft routes chunks', error);
        });
    }

  }

  private _setDraftAnalysis() {
    this.planningDraftsService.getDraftAnalysis(this.draft.id)
      .then((analysis) => {
        this.analysis = analysis;
      })
  }

  // private _setJobsByStatus(jobs) {
  //   const map = {
  //     All: [],
  //     NotScheduled: [],
  //     Scheduled: []
  //   };
  //   _.forEach(jobs, (j) => {
  //     const status = j.orderStatus;
  //     if (!map[status]) {
  //       _.set(map, status, [])
  //     }
  //     map[status].push(j);
  //     map.All.push(j);
  //   });
  //   return map;
  // }

  private _deleteRoutes(routeIds: string[]) {
    // Get resource IDs from routes being deleted
    const deletedRoutes = _.filter(this.routes, (r) => {
      return _.includes(routeIds, r.id);
    });
    const deletedRouteResourceIds = _.map(deletedRoutes, 'resourceId');

    this.planningDraftsService.deleteRoutesInDraft(routeIds, this.project.id, this.draft.id)
      .then((deletedRouteIds) => {
        const routes = _.filter(this.routes, (r) => {
          return !_.includes(deletedRouteIds, r.id);
        })
        this.routes = this._getSortedRoutes(routes);
        this.hiddenRouteIds = _.difference(this.hiddenRouteIds, deletedRouteIds as string[]);
        this.selectedRouteIds = [];

        // Update resources' routed flag to false for deleted routes
        // Create new array reference for Angular change detection
        // Only for non-vehicle resources (vehicle resources have amount tracking instead)
        this.resources = _.map(this.resources, (resource) => {
          if (_.includes(deletedRouteResourceIds, resource.id) && resource.source !== 'Vehicle') {
            return {...resource, routed: false};
          }
          return resource;
        });
      })
  }

  private _deleteDraft() {
    this.planningDraftsService.deleteDraftsFromProject([this.draft.id], this.project)
      .then(() => {
        this.$state.go(this.planningConstants.states.project, {
          projectId: this.project.id,
          draftId: undefined
        });
      })
      .catch((error) => {
        this.$log.error(error);
      })
  }

  // private _onJobsRemoved(ids) {
  //   this.selectedJobIds = [];
  //   this.selectedLeftoverIds = [];
  //   this.jobs = _.filter(this.jobs, (j) => {
  //     return !_.includes(ids, j.id);
  //   });
  //   this._setServiceAreasByJobs(this.jobs);
  // }

  // private _getJobsOutOfProjectScope(project) {
  //   if (!project.jobs) {
  //     return [];
  //   }
  //   return _.filter(project.jobs, (j) => {
  //     const stopsRef = _.get(j, 'stops', []),
  //       jobNotBefore = _.get(stopsRef, '[0].notBefore'),
  //       lastStopRef = stopsRef[stopsRef.length - 1],
  //       jobNotAfter = _.get(lastStopRef, 'notBefore');
  //
  //     if (jobNotBefore && jobNotAfter) {
  //       return jobNotBefore < project.from || jobNotAfter > project.to;
  //     } else {
  //       return false;
  //     }
  //
  //   })
  // }

  private _approveAndDispatch(draftId, dispatchLeftovers, autoAssignRoutes, keepProjectOpen) {
    this.isLoading = true;
    this.planningDraftsService.approveAndDispatchDraft(draftId, this.project, dispatchLeftovers, autoAssignRoutes, keepProjectOpen)
      .then(() => {
      })
      .catch(() => {
        this.isLoading = false;
      })
      .finally(() => {
        this.isLoading = false;
      })
  }

  private _createRouteToDraft(resourceId, jobIds, routeName?, stopIdOrder?, optimize?, allowSkillsMismatch?: boolean) {
    if (!jobIds) {
      jobIds = [];
    }
    this.planningDraftsService.createRouteInDraft(resourceId, jobIds, this.project.id, this.draft.id, this.isGroupedRoutes, routeName, stopIdOrder, optimize, allowSkillsMismatch)
      .then((createdRoute: any) => {
        const currentRouteIds = _.map(this.routes, 'id');

        // See if it causes duplicate routes
        if (!_.includes(currentRouteIds, createdRoute.id)) {
          const routes = this.routes.concat(createdRoute);
          this.routes = this._getSortedRoutes(routes);
        }

        this._resetSelectedJobs();
      })
  }

  private _getDraftJobs(ids?) {
    return this.planningDraftsService.getJobs(this.project.id, this.draft.id, ids);
  }

  private _getDepots() {
    if (this.project.snapshot) {
      return;
    }

    this.planningProjectsService.getDepots(this.project.id)
      .then((depots: DepotModel[]) => {
        this.depots = depots || [];
      });
  }

  private _getJobs() {
    this.isLoading = true;
    this._getDraftJobs()
      .then((jobs: any) => {
        this.jobs = jobs || [];
        this._updateDraftJobs(this.draft);
        this._setLeftoversByJobIds(this.draft.leftoversIds);
      })
      .finally(() => {
        this.isLoading = false;
      })
  }

  private _getDraftResources() {
    this.isLoading = true;
    this.planningDraftsService.getResources(this.project.id, this.draft.id)
      .then((resources) => {
        this._updateDraftResources(this.draft, resources, true);
      })
      .finally(() => {
        this.isLoading = false;
      })
  }

  private _getDraftRoutes(routeIds?) {
    return this.planningDraftsService.getRoutes(this.project.id, this.draft.id, routeIds, this.isGroupedRoutes);
  }

  private _setLeftoversByJobIds(leftoversIds) {
    const leftoverJobs = _.filter(this.jobs, (j) => {
      return _.includes(leftoversIds, j.id)
    });
    this.leftoverStops = this._getLeftoverStops(leftoverJobs);
  }

  private _getLeftoverStops(jobs) {
    const stops = [];

    _.forEach(jobs, (j) => {
      _.forEach(j.stops, (s) => {
        stops.push(s);
      })
    });
    return stops;
  }

  private _updateDraftJobs(draft) {
    const draftRoutedJobIds = _.get(draft, 'routedJobsIds', []);
    const draftExcludedJobIds = _.get(draft, 'excludedJobsIds', []);

    const updatedJobs = angular.copy(this.jobs);
    _.forEach(updatedJobs, (j) => {
      const route = _.find(this.routes, (route) => {
        return _.includes(route.jobIds, j.id);
      });

      j.routed = _.includes(draftRoutedJobIds, j.id);
      j.excluded = _.includes(draftExcludedJobIds, j.id);
      j.routeId = _.get(route, 'id');
      j.resourceName = _.get(route, 'resource.allocationName') || _.get(route, 'resource.vehicleName');
    });

    this.jobs = updatedJobs;

    this._setServiceAreasByJobs(this.jobs);
  }

  private _updateDraftResources(draft, resources, doSort?: boolean) {
    const draftRoutedResourceIds = _.get(draft, 'routedResourcesIds', []);
    const draftExcludedResourceIds = _.get(draft, 'excludedResourcesIds', []);

    // Get actual routed resource IDs from existing routes
    const actualRoutedResourceIds = _.map(this.routes, 'resourceId');

    _.forEach(resources, (r) => {
      const route = _.find(this.routes, (route) => {
        return _.get(route, 'resourceId') === r.id;
      });

      // Use actual route existence for routed status, not draft's potentially stale data
      // This ensures resources from deleted routes are immediately available
      r.routed = _.includes(actualRoutedResourceIds, r.id);
      r.routeStatus = _.get(route, 'status');
      r.excluded = _.includes(draftExcludedResourceIds, r.id);
      r.routeId = _.get(route, 'id');
      r.routeTotals = _.get(route, 'totals', {});
    })

    this.resources = doSort ?
      this._getSortedResources(resources) :
      resources;
    // this.resources = this._getSortedResources(resources);
  }

  private _updateDraft(draft) {
    this.planningDraftsService.updateDraft(draft, this.draft.id, this.project)
      .then((updatedDraft) => {
        this.draft = updatedDraft;
      })
  }

  private _updateDraftAndReoptimize(draft) {
    this.planningDraftsService.updateDraft(draft, this.draft.id, this.project)
      .then((updatedDraft) => {
        this.draft = updatedDraft;
        this.timelineEnabled = true;
        this.onOptimizeDraft(draft);
      })
  }

  private _updateDraftSettings(settings) {
    this.planningDraftsService.updateDraftSettings(settings, this.draft.id, this.project)
      .then((updatedDraft) => {
        this.draft = updatedDraft;
      })
  }

  private _resetSelectedJobs() {
    this.selectedJobIds = [];
    this.selectedJobs = [];
    this.selectedLeftoverIds = [];
  }


  private setSelectedJobs() {
    this.selectedJobs = _.chain(this.selectedJobIds)
      .map((id) => {
        return _.find(this.jobs, (j) => {
          return j.id === id;
        })
      })
      .compact()
      .value();
  }

  private _getHasDefaultViewSettingsChanged(viewSettings: PlanningViewSettingsModel): boolean {
    const defaultSettings = this._getDefaultViewSettings();
    const paths = [
      'jobs.columns',
      'jobs.load',
      'jobs.general',
      'routes.columns',
      'routes.load',
      'routes.capacity',
      'route.columns',
      'route.load',
      'route.capacity',
      'resources.columns',
      'resources.load',
      'resources.capacity',
      'draft.columns'
    ];

    return paths.some(path => {
      const defaultKeys = _.keys(_.get(defaultSettings, path));
      const currentKeys = _.keys(_.get(viewSettings, path));

      return !_.isEqual(defaultKeys.sort(), currentKeys.sort());
    });
  }

  private _getDefaultViewSettings(): PlanningViewSettingsModel {
    return this.planningConstants.defaultViewSettings;
  }

  private _exportDraftRoutesLoadingSheetSvg(routeIds?, email?) {
    this.planningDraftsService.exportDraft(this.project.id, this.draft.id, PlanningDraftExportType.ROUTES_LOADING, routeIds, email)
      .then(() => {
        this.selectedRouteIds = [];
      })
      .catch((error) => {
        this.$log.error(error);
      })
  }

  private _updateRouteName(routeId: string, routeName: string) {
    const payload: PlanningDraftEditRouteNameRequestModel = {
      routeName: routeName
    };

    this.planningDraftsService.updateRouteName(this.project.id, this.draft.id, routeId, payload)
      .then((updatedRoute: any) => {
        const routesCopy = angular.copy(this.routes);
        const routeIndex = routesCopy.findIndex((route) => {
          return route.id === updatedRoute.id;
        })

        if (routeIndex > -1) {
          routesCopy[routeIndex] = updatedRoute;
        }

        this.routes = routesCopy;
      })
  }

  private _updateRouteColor(routeId: string, routeColor: string) {
    const payload: PlanningDraftEditRouteColorRequestModel = { routeColor };

    this.planningDraftsService.updateRouteColor(this.project.id, this.draft.id, routeId, payload)
      .then((updatedRoute: any) => {
        const routesCopy = angular.copy(this.routes);
        const routeIndex = routesCopy.findIndex((route) => {
          return route.id === updatedRoute.id;
        })

        if (routeIndex > -1) {
          routesCopy[routeIndex] = updatedRoute;
        }

        this.routes = routesCopy;
      })
  }

  updateRouteResource(route, resourceId) {
    if (this.draft.settings?.planRetrips) {
      this.planningDraftsService.changeRouteResource(this.project.id, this.draft.id, route.id, resourceId)
    } else {
      const payload: RouteSwapResourceRequestModel[] = [{
        routeId: route.id,
        originalResourceId: _.get(route, 'resource.id'),
        destinationResourceId: resourceId
      }]

      const swapRouteFrom = _.find(this.routes, (r) => {
        return r.resource?.id === resourceId;
      })

      if (!!swapRouteFrom) {
        payload.push({
          routeId: swapRouteFrom.id,
          originalResourceId: _.get(swapRouteFrom, 'resource.id'),
          destinationResourceId: _.get(route, 'resource.id')
        })
      }

      this.planningDraftsService.swapRouteResources(this.project.id, this.draft.id, payload)
        .then((updatedRoutes: any[]) => {
          const routesCopy = angular.copy(this.routes);
          updatedRoutes.forEach((r) => {
            const routeIndex = routesCopy.findIndex((route) => {
              return route.id === r.id;
            })

            if (routeIndex > -1) {
              routesCopy[routeIndex] = r;
            }
          })

          this.routes = routesCopy;
        })
    }
  }

  private _updateRoutePickingTimeOffset(routeId: string, pickingTimeOffsetInMinutes: number) {
    this.planningDraftsService.updateRoutePickingTimeOffset(this.project.id, this.draft.id, routeId, pickingTimeOffsetInMinutes)
      .then((updatedRoute: PlanningRouteModel) => {
        const routesCopy = angular.copy(this.routes);

        const routeIndex = routesCopy.findIndex((route) => {
          return route.id === routeId;
        })

        if (routeIndex > -1) {
          routesCopy[routeIndex] = updatedRoute;
        }

        this.routes = routesCopy;
      })
  }

  // private setSelectedDraftInProject(draftId: string) {
  //   if (this.project.selectedDraftId !== draftId) {
  //     this.planningProjectsService.setSelectedDraft(this.project.id, draftId)
  //       .then((selectedDraft: any) => {
  //         this.project.selectedDraftId = selectedDraft.id;
  //       })
  //   }
  // }

  onContextMenu(event, job) {
    const availableActions = this._getJobAvailableActions(job);
    const panel = this.panelService.open(
      BringozMenuPanelComponent, event, [{
        ...PLANNING_DRAFT_JOB_MENU_ITEMS.createRoute,
        disabled: !availableActions.createRoute,
      }, {
        ...PLANNING_DRAFT_JOB_MENU_ITEMS.assignToRoute,
        disabled: !availableActions.assignToRoute,
      }, {
        ...PLANNING_DRAFT_JOB_MENU_ITEMS.addToDraft,
        disabled: !availableActions.addToDraft,
      }, {
        ...PLANNING_DRAFT_JOB_MENU_ITEMS.moveToLeftovers,
        disabled: !availableActions.moveToLeftovers,
      }, {
        ...(job.lockedRouteId ? PLANNING_DRAFT_JOB_MENU_ITEMS.unlock : PLANNING_DRAFT_JOB_MENU_ITEMS.lock),
        disabled: !availableActions.toggleLock,
      }, {
        ...PLANNING_DRAFT_JOB_MENU_ITEMS.removeFromDraft,
        disabled: !availableActions.removeFromDraft,
      }, {
        name: 'Split Packages',
        action: 'splitByPackages',
        iconName: 'BOX',
        disabled: job.routed,
      }, {
        name: 'Insert Stop',
        action: 'insertStop',
        iconName: 'location-pin-outline',
        disabled: job.routed,
      }], {
        position: {
          originX: 'center',
          originY: 'top',
          overlayX: 'start',
          overlayY: 'top',
        },
        width: 180
      });

    if (panel) {
      if (this._jobSplitPanelSubscription) {
        this._jobSplitPanelSubscription.unsubscribe();
      }
      this._jobSplitPanelSubscription = panel.instance.onClose
        .subscribe((action: string) => {
          switch (action) {
            case 'createRoute':
              this.onCreateRouteByJobs([job.id], undefined);
              break;
            case 'assignToRoute':
              this.onUpdateRouteByJobs([job.id], undefined);
              break;
            case 'addToDraft':
              this.onAddJobs([job.id]);
              break;
            case 'moveToLeftovers':
              this.onMoveToLeftovers([job.id]);
              break;
            case 'toggleLock':
              this.onToggleLockJobs([job.id], !job.lockedRouteId);
              break;
            case 'removeFromDraft':
              this.onRemoveJobs([job.id]);
              break;
            case 'splitByPackages':
              this._jobSplitByPackages(event, job)
              break;
            case 'insertStop':
              this._jobSplitByInsertStops(event, job)
              break;
            default:
              break;
          }
        })
    }
  }

  private _getJobAvailableActions(job: any) {
    const isRouted: boolean = !!job.routed;
    const isExcluded: boolean = !!job.excluded;
    const isRouteLocked: boolean = !!_.find(this.routes, (r) => _.includes(r.jobIds, job.id))?.locked;
    const isLocked: boolean = !!job.lockedRouteId || isRouteLocked;

    return {
      addToDraft: isExcluded,
      removeFromDraft: !isExcluded,
      createRoute: !isLocked,
      assignToRoute: !isRouteLocked,
      moveToLeftovers: isRouted && !isRouteLocked,
      toggleLock: isRouted && !isRouteLocked
    };
  }

  private _jobSplitByPackages(event, job) {
    // update resources with route data if they are routed
    const routedResources = this.resources.reduce((acc, resource) => {
      const resourceRoutes = this.routes.filter(route => route.resourceId === resource.id);

      // If no route found set params as null
      if (!resourceRoutes.length) {
        acc.push({
          ...resource,
          routeId: null,
          routeName: null,
          routeTotals: null,
          route: null
        });
        return acc;
      }

      // For each route instance that uses the resource, create a `resourceRoute` 'dto'
      resourceRoutes.forEach(routedResource => {
        acc.push({
          ...resource,
          routeId: routedResource.id,
          routeName: routedResource.name,
          routeTotals: routedResource.totals,
          route: routedResource
        });
      });

      return acc;
    }, []);

    const panel = this.panelService.open(PlanningDraftRouteJobSplitByPackagesComponent, event,
      {
        job,
        resources: routedResources,
      },
      {
        position: {
          originX: 'start',
          originY: 'top',
          overlayX: 'start',
          overlayY: 'top',
        },
        height: 320,
        width: 460
      })

    if (panel) {
      if (this._jobSplitSubscription) {
        this._jobSplitSubscription.unsubscribe();
      }
      this._jobSplitSubscription = panel.instance.onSplitJobByPackages.subscribe(({packages, resourceId, routeId, optimize}) => {
        this.planningDraftsService.splitAndAssignJobByPackages(this.project.id, this.draft.id, job.id, {splits: [{packages, resourceId, routeId}]}, optimize)
          .then((updatedJobs: any) => {
            // Replace the original job in place with the split jobs
            const jobsCopy = angular.copy(this.jobs);
            const originalIndex = jobsCopy.findIndex(currentJob => currentJob.id === job.id);
            jobsCopy.splice(originalIndex, 1, ...updatedJobs);
            this.jobs = jobsCopy;

            this.onSelectedJobsChange(updatedJobs.map(currentJob => currentJob.id));
            this._scrollToJob(updatedJobs[0]?.id);

            this.planningAlertsService.jobSplitSuccess();

          })
      })
    }
  }

  private _jobSplitByInsertStops(event, job) {
    const panel = this.panelService.open(PlanningDraftRouteJobSplitByLocationComponent, event,
      {job, depots: this.depots, event},
      {
        position: {
          originX: 'start',
          originY: 'top',
          overlayX: 'start',
          overlayY: 'top',
        },
        height: 260,
        width: 340
      })

    if (panel) {
      if (this._jobSplitSubscription) {
        this._jobSplitSubscription.unsubscribe();
      }
      this._jobSplitSubscription = panel.instance.onInsertStop
        .subscribe((depot) => {
          const request = {
            stops: [{
              address: {
                locationId: depot.id,
                locationType: "DEPOT"
              }
            }]
          }

          this.planningDraftsService.splitJobByLocation(this.project.id, this.draft.id, job.id, request)
            .then((updatedJobs: any) => {
              const jobsCopy = angular.copy(this.jobs);
              const originalIndex = jobsCopy.findIndex(currentJob => currentJob.id === job.id);
              jobsCopy.splice(originalIndex, 1, ...updatedJobs);
              this.jobs = jobsCopy;

              this.onSelectedJobsChange(updatedJobs.map(currentJob => currentJob.id));
              this._scrollToJob(updatedJobs[0]?.id);

              this.planningAlertsService.jobSplitSuccess();

            })
        })
    }
  }

  onReverseJobSplit(event, job) {
    this.planningDraftsService.getJobSplitSuggestions(this.project.id, this.draft.id, job.splitSuggestionId)
      .then((jobSuggestions: any) => {
        let subJobIds: any[] = jobSuggestions.suggestionInformation.subJobs.map(subJob => subJob.id);

        const otherJobRoute = this.routes.find(route => {
          return subJobIds.some(subJobId =>
            route.jobIds.includes(subJobId) && subJobId !== job.id
          );
        });

        const now = Date.now();
        let isCurrentJobInLockedRoute = false;
        let isOtherJobInLockedRoute = false;

        // Take job ID from the suggestion snapshot, then use it to search the updated corresponding job in draft jobs
        const otherSubJobId = jobSuggestions.suggestionInformation.subJobs
          .find(subJob => subJob.id !== job.id)?.id;
        const otherSubJob = this.jobs.find(currentJob => currentJob.id === otherSubJobId);

        // A sync can remove a piece of the split, leaving no other sub job to compare against
        const isAnyJobDispatched = !!otherSubJob && job.fulfillmentStepId !== otherSubJob.fulfillmentStepId;

        this.routes.some(route => {
          const isLockedRoute = route.locked || (route.actionProcess?.running && now < route.actionProcess.expirationDate);

          if (!isLockedRoute) {
            return false;
          }

          if (route.jobIds.includes(job.id)) {
            isCurrentJobInLockedRoute = true;
          }

          if (otherSubJob && route.jobIds.includes(otherSubJob.id)) {
            isOtherJobInLockedRoute = true;
          }

          return isCurrentJobInLockedRoute && isOtherJobInLockedRoute;
        });
        const panel = this.panelService.open(PlanningDraftRouteJobSplitRevertComponent, event,
          {jobSuggestions, otherJobRoute, otherSubJob, isCurrentJobInLockedRoute, isOtherJobInLockedRoute, isAnyJobDispatched},
          {
            position: {
              originX: 'start',
              originY: 'top',
              overlayX: 'start',
              overlayY: 'top',
            },
            height: 260,
            width: 340
          });

        if (panel) {
          if (this._jobSplitSubscription) {
            this._jobSplitSubscription.unsubscribe();
          }

          this._jobSplitSubscription = panel.instance.onReverseJobSplit
            .subscribe((splitSuggestionId: string) => {
              this.planningDraftsService.reverseJobSplit(this.project.id, this.draft.id, splitSuggestionId)
                .then((revertedJob: any) => {
                  const insertIndex = this.jobs.findIndex(j => subJobIds.includes(j.id));
                  let jobsCopy = this.jobs.filter(j => !subJobIds.includes(j.id));
                  if (insertIndex >= 0 && insertIndex < jobsCopy.length) {
                    jobsCopy.splice(insertIndex, 0, revertedJob);
                  } else {
                    jobsCopy.push(revertedJob);
                  }
                  this.jobs = angular.copy(jobsCopy);

                  this.onSelectedJobsChange([revertedJob.id]);
                  this._scrollToJob(revertedJob.id);

                  switch (jobSuggestions.suggestionInformation.type) {
                    case 'SPLIT_LOCATION':
                      this.planningAlertsService.jobsSplitRevertByLocationSuccess();
                      break;
                    case 'SPLIT_PACKAGES':
                      this.planningAlertsService.jobsSplitRevertByPackagesSuccess();
                      break;
                    default:
                      break;
                  }
                })
            })
        }
      })
  }

  private _scrollToJob(jobId: string) {
    if (!jobId) return;
    this.$timeout(() => {
      const el = document.getElementById(jobId);
      el?.scrollIntoView({behavior: 'smooth', block: 'center'});
    }, 600);
  }

  private _getSortedRoutes(routes) {
    return _.orderBy(routes, ['resource.allocationName', 'resource.vehicleName', 'routeGroupId', 'sequenceInRouteGroup', 'resource.allocationInstanceId'], ['asc', 'asc', 'asc', 'asc']);
  }

  onBulkJobSplit(data: { approve: any[], deny: any[], optimize: any[] }) {
    // CON-12971: Need to compute ids for `deny`, in the future we'll do the same for approve
    const denyIds = data.deny.map(s => s.id);
    const payload = {
      approve: data.approve,
      denyIds
    };
    this.planningDraftsService.bulkJobSplit(this.project.id, this.draft.id, payload)
      .then((response: any[]) => {
        const subJobIdsSet = new Set(
          [...data.approve, ...data.deny, ...data.optimize].map(suggestion => suggestion.sourceId)
        );

        // filter jobs with decisions and append newly created jobs from split
        let jobsCopy = this.jobs.filter(j => !subJobIdsSet.has(j.id));

        const responseSubJobs = _.flatMap(response, suggestion => suggestion.suggestionInformation.subJobs);

        jobsCopy = [...jobsCopy, ...responseSubJobs];

        this.jobs = angular.copy(jobsCopy);

        this.planningAlertsService.bulkJobSplitSuccess();
      })
  }

  private _refreshRoutes(updatedRoutes) {
    const updatedMap = _.keyBy(updatedRoutes, 'id');
    const routesCopy = this.routes.map((route) => updatedMap[route.id] || route);
    const routes = _.uniqBy(routesCopy, 'id');

    this.routes = this._getSortedRoutes(routes);
  }

  onClusterToggle(clusterId: string, routeIds: string[], jobIds: string[]) {
    this.selectedClusterId = clusterId === this.selectedClusterId ? '' : clusterId;
    this.highlightedRouteIds = this.selectedClusterId ? new Set(routeIds) : null;
    this.highlightedLeftoverIds = this.selectedClusterId ? new Set(jobIds) : null;
  }
}

angular
  .module('bringoz.admin.planning')
  .component('planningProjectDraftViewNew', {
    bindings: {
      project: '<',
      projectStatus: '<',
      draft: '<',
      analysis: '<',
      jobs: '<?',
      viewSettings: '<?',
      viewSettingsColumns: '<?',
    },
    template: require('./planning-project-draft-view-new.html').default,
    controller: PlanningProjectDraftViewNewComponent
  });
